import projectData from './project-data';

/* eslint-disable import/no-unresolved */
import popWav from '!arraybuffer-loader!./83a9787d4cb6f3b7632b4ddfebf74367.wav';
import meowWav from '!arraybuffer-loader!./83c36d806dc92327b9e7049a565c6bff.wav';
import backdrop from '!raw-loader!./cd21514d0531fdffb22204e0ec5ed84a.svg';

//Sounds
import BasketballBounce from '!arraybuffer-loader!./1727f65b5f22d151685b8e5917456a60.wav';
import Chomp from '!arraybuffer-loader!./0b1e3033140d094563248e61de4039e5.wav';
import Boing from '!arraybuffer-loader!./53a3c2e27d1fb5fdb14aaf0cb41e7889.wav';
import Bite from '!arraybuffer-loader!./0039635b1d6853face36581784558454.wav';
import Owl from '!arraybuffer-loader!./e8b6d605f5a1bb36c29e4e21ef754209.wav';
import Xylo1 from '!arraybuffer-loader!./6ac484e97c1c1fe1384642e26a125e70.wav';
import BellToll from '!arraybuffer-loader!./25d61e79cbeba4041eebeaebd7bf9598.wav';
import GoalCheer from '!arraybuffer-loader!./a434069c58e79d42f5d21abb1c318919.wav';
import RefereeWhistle from '!arraybuffer-loader!./8468b9b3f11a665ee4d215afd8463b97.wav';
import Birthday from '!arraybuffer-loader!./89691587a169d935a58c48c3d4e78534.wav';
import Meow2 from '!arraybuffer-loader!./cf51a0c4088942d95bcc20af13202710.wav';
import Snort from '!arraybuffer-loader!./362d7440a57cab29914fecea621e50d4.wav';
import Chirp from '!arraybuffer-loader!./3b8236bbb288019d93ae38362e865972.wav';
import ClownHonk from '!arraybuffer-loader!./ec66961f188e9b8a9c75771db744d096.wav';
import CarVroom from '!arraybuffer-loader!./ead1da4a87ff6cb53441142f7ac37b8f.wav';
import MagicSpell from '!arraybuffer-loader!./1cb60ecdb1075c8769cb346d5c2a22c7.wav';
import Collect from '!arraybuffer-loader!./32514c51e03db680e9c63857b840ae78.wav';
import Dog1 from '!arraybuffer-loader!./b15adefc3c12f758b6dc6a045362532f.wav';
import Bark from '!arraybuffer-loader!./cd8fa8390b0efdd281882533fbfcfcfb.wav';
import Bird from '!arraybuffer-loader!./18bd4b634a3f992a16b30344c7d810e0.wav';
import HighTom from '!arraybuffer-loader!./d623f99b3c8d33932eb2c6c9cfd817c5.wav';
import LowTom from '!arraybuffer-loader!./1569bbbd8952b0575e5a5cb5aefb50ba.wav';
import DrumBass1 from '!arraybuffer-loader!./48328c874353617451e4c7902cc82817.wav';
import DrumBass2 from '!arraybuffer-loader!./711a1270d1cf2e5de9b145ee539213e4.wav';
import DrumBass3 from '!arraybuffer-loader!./c21704337b16359ea631b5f8eb48f765.wav';
import CrashCymbal from '!arraybuffer-loader!./f2c47a46f614f467a7ac802ed9ec3d8e.wav';
import SplashCymbal from '!arraybuffer-loader!./9d63ed5be96c43b06492e8b4a9cea8d8.wav';
import BellCymbal from '!arraybuffer-loader!./efddec047de95492f775a1b5b2e8d19e.wav';
import RollCymbal from '!arraybuffer-loader!./da8355d753cd2a5ddd19cb2bb41c1547.wav';
import HihatCymbal from '!arraybuffer-loader!./2d01f60d0f20ab39facbf707899c6b2a.wav';
import TapSnare from '!arraybuffer-loader!./d55b3954d72c6275917f375e49b502f3.wav';
import FlamSnare from '!arraybuffer-loader!./3b6cce9f8c56c0537ca61eee3945cd1d.wav';
import SidestickSnare from '!arraybuffer-loader!./f6868ee5cf626fc4ef3ca1119dc95592.wav';
import HighConga from '!arraybuffer-loader!./16144544de90e98a92a265d4fc3241ea.wav';
import LowConga from '!arraybuffer-loader!./0b6f94487cd8a1cf0bb77e15966656c3.wav';
import MutedConga from '!arraybuffer-loader!./1d4abbe3c9bfe198a88badb10762de75.wav';
import TapConga from '!arraybuffer-loader!./fd9a67157f57f9cc6fe3cdce38a6d4a8.wav';
import HiNaTabla from '!arraybuffer-loader!./35b42d98c43404a5b1b52fb232a62bd7.wav';
import HiTunTabla from '!arraybuffer-loader!./da734693dfa6a9a7eccdc7f9a0ca9840.wav';
import LoGehTabla from '!arraybuffer-loader!./9205359ab69d042ed3da8a160a651690.wav';
import LoGlissTabla from '!arraybuffer-loader!./d7cd24689737569c93e7ea7344ba6b0e.wav';
import DuckS from '!arraybuffer-loader!./af5b039e1b05e0ccb12944f648a8884e.wav';
import Bubbles from '!arraybuffer-loader!./78b0be9c9c2f664158b886bc7e794095.wav';
import OceanWave from '!arraybuffer-loader!./c904610d770398b98872a708a2f75611.wav';
import WaterDrop from '!arraybuffer-loader!./aa488de9e2c871e9d4faecd246ed737a.wav';
import CarHorn from '!arraybuffer-loader!./7c887f6a2ecd1cdb85d5527898d7f7a0.wav';
import WolfHowl from '!arraybuffer-loader!./5e36d74bb16aa5085b901362788b0fbf.wav';
import SpaceRipple from '!arraybuffer-loader!./ff8b8c3bf841a11fd5fe3afaa92be1b5.wav';
import HorseGallop from '!arraybuffer-loader!./058a34b5fb8b57178b5322d994b6b8c8.wav';
import Cheer from '!arraybuffer-loader!./170e05c29d50918ae0b482c2955768c0.wav';
import FairyDust from '!arraybuffer-loader!./b92de59d992a655c1b542223a784cda6.wav';

import HorseS1 from '!arraybuffer-loader!./45ffcf97ee2edca0199ff5aa71a5b72e.wav';
import HorseS2 from '!arraybuffer-loader!./058a34b5fb8b57178b5322d994b6b8c8.wav';

import DanceCelebrate from '!arraybuffer-loader!./0edb8fb88af19e6e17d0f8cf64c1d136.wav';
import CheeChee from '!arraybuffer-loader!./25f4826cdd61e0a1c623ec2324c16ca0.wav';

import ComputerBeeps1 from '!arraybuffer-loader!./1da43f6d52d0615da8a250e28100a80d.wav';
import ComputerBeeps2 from '!arraybuffer-loader!./28c76b6bebd04be1383fe9ba4933d263.wav';

import BuzzWhir from '!arraybuffer-loader!./d4f76ded6bccd765958d15b63804de55.wav';

import Laser1 from '!arraybuffer-loader!./46571f8ec0f2cc91666c80e312579082.wav';
import Laser2 from '!arraybuffer-loader!./27654ed2e3224f0a3f77c244e4fae9aa.wav';


//Assets
import codemino from '!raw-loader!./bcf454acf82e4504149f7ffe07081dbc.svg';

import Finder from '!raw-loader!./finder-square1.svg';

/*
import Box1 from '!raw-loader!./bimafdy83stli9srf69r5bn4osil6ocr.svg';
import Box2 from '!raw-loader!./kro9ftjwbshdwaujf208g8cngpvrdnbs.svg';
import Box3 from '!raw-loader!./mbjtwxlkkyyl9o4b7236xhbnc0g2z5uu.svg';
import Box4 from '!raw-loader!./prmfoqlf9ew9exrt4iuvvh5qp0vq6i1e.svg';
import Box5 from '!raw-loader!./rtn8qriyeymp0nga029meto5stg3znw7.svg';
import Box6 from '!raw-loader!./t9c45v1q96mfd81y9p56n6qdlc5c3o26.svg';
*/
import Gold from '!raw-loader!./2838de5d131785c985eb0eab25ec63af.svg';

import TenisBall from '!raw-loader!./80c8f32282b697097933837905a6f257.svg';

import Award from '!raw-loader!./643896fcad0a1bf6eb9f3f590094687c.svg';

import Crate from '!raw-loader!./c2f77473dd16d1a3713218b05390a688.svg';

import Pontoon from '!raw-loader!./17ef8f63a2a8f47258bd62cf642fd8d6.svg';

import Diamond from '!raw-loader!./935c7cf21c35523c0a232013a6399a49.svg';

import Award1 from '!raw-loader!./ecf86afea23fd95e27d4e63659adbfa6.svg';

import Star2 from '!raw-loader!./40ffad793f4042a5fe7b3aaa6bc175ae.svg';

import Ground1 from '!raw-loader!./0bdd31ea2b3b78d0c39022795a49c69a.svg';
import Ground2 from '!raw-loader!./40bf3880b678beeda8cf708a51a4402d.svg';

import Looding1 from '!raw-loader!./0fc3ac08468935694255ef8a461d4d26.svg';
import Looding2 from '!raw-loader!./ec4d85a60c32c7637de31dbf503266a0.svg';
import Looding3 from '!raw-loader!./9bf9e677da34528433d3c1acb945e2df.svg';
import Looding4 from '!raw-loader!./42e5468fa164e001925d5a49d372f4b1.svg';

import Car1 from '!raw-loader!./3c46f5192d2c29f957381e0100c6085d.svg';
import Car2 from '!raw-loader!./4b1beecd9a8892df0918242b2b5fbd4c.svg';
import Car3 from '!raw-loader!./5e61610cbba50ba86f18830f61bbaecb.svg';
import Car4 from '!raw-loader!./5f8301434ce176ab328f5b658ee1ec05.svg';
import Car5 from '!raw-loader!./22817ed2e4253787c78d7b696bbefdc1.svg';
import Car6 from '!raw-loader!./648cfdd48a7f748e6198194669ba1909.svg';

import Racer1 from '!raw-loader!./3c3f44aba3eff8856472e06b333a7201.svg';
import Racer2 from '!raw-loader!./5c1d38d02ae9c4df7851a6e9d52f25b4.svg';
import Racer3 from '!raw-loader!./47b9f910048ce4db93bdfbcd2638e19a.svg';
import Racer4 from '!raw-loader!./001a2186db228fdd9bfbf3f15800bb63.svg';
import Racer5 from '!raw-loader!./fd2a94481c3ef0c223784b2f3c6df874.svg';
import Racer6 from '!raw-loader!./5a113fcacd35ababbf23c5a9289433d1.svg';

import GameButtons1 from '!raw-loader!./43a89fc1442627ca48b1dc631c517942.svg';
import GameButtons2 from '!raw-loader!./1a41f74cd76d7202d8b22ffc7729e03f.svg';
import GameButtons3 from '!raw-loader!./377eac55366670a03c469705c6689f09.svg';
import GameButtons4 from '!raw-loader!./9cf707e83af27c47e74adb77496ffca5.svg';
import GameButtons5 from '!raw-loader!./84a6dc992bce018a1eac9be0173ad917.svg';
import GameButtons6 from '!raw-loader!./efc27a91c30d6a511be4245e36684192.svg';
import GameButtons7 from '!raw-loader!./01acd1076994a4379a3fc9e034bc05fc.svg';
import GameButtons8 from '!raw-loader!./4f217b14a161fcd9590614b0733100ea.svg';

import Flag from '!raw-loader!./0cb908dbc38635cc595e6060afc1b682.svg';

import Astronot1 from '!raw-loader!./a09376e1eacf17be3c9fbd268674b9f7.svg';
import Astronot2 from '!raw-loader!./f6ff602902affbae2f89b389f08df432.svg';

import SpaceShip1 from '!raw-loader!./a09376e1eacf17be3c9fbd268674b9f7.svg';
import SpaceShip2 from '!raw-loader!./f6ff602902affbae2f89b389f08df432.svg';

import Phantom1 from '!raw-loader!./6bd5cb8bc3e4df5e055f4c56dd630855.svg';
import Phantom2 from '!raw-loader!./8fb61932544adbe8c95b067ad1351758.svg';

import Monstrous1 from '!raw-loader!./130cc4b9ad8dd8936d22c51c05ac6860.svg';
import Monstrous2 from '!raw-loader!./b28d76f648ad24932a18cb40c8d76bc5.svg';
import Monstrous3 from '!raw-loader!./dd713e3bf42d7a4fd8d2f12094db1c63.svg';
import Monstrous4 from '!raw-loader!./3005df22798da45f1daf1de7421bb91d.svg';


import Ozi1 from '!raw-loader!./add5c5a8eec67eb010b5cbd44dea5c8d.svg';
import Ozi2 from '!raw-loader!./4e903ac41a7e16a52efff8477f2398c7.svg';
import Ozi3 from '!raw-loader!./83565581ecc9f7d4010efd8683a99393.svg';
import Ozi4 from '!raw-loader!./4a3ae31dd3dd3b96239a0307cfdaa1b6.svg';

import Cyclop1 from '!raw-loader!./d4ec9a1827429f4e2f3dc239dcc15b95.svg';
import Cyclop2 from '!raw-loader!./85144902cc61fe98dca513b74276d7d8.svg';

import FireFox1 from '!raw-loader!./eec286b1cfea3f219a5b486931abedd2.svg';
import FireFox2 from '!raw-loader!./70520daa9f82a2347c8a8fa9e7fe1a6e.svg';
import FireFox3 from '!raw-loader!./99aae97a2b49904db7eeb813fa968582.svg';
import FireFox4 from '!raw-loader!./2c156e20da1ad4e8e397a89ad8fb1c26.svg';
import FireFox5 from '!raw-loader!./1bceea90292a51a7177abf581f28bf2c.svg';
import FireFox6 from '!raw-loader!./9cad752323aa81dfa8d8cf009057b108.svg';

import Abby1 from '!raw-loader!./809d9b47347a6af2860e7a3a35bce057.svg';
import Abby2 from '!raw-loader!./920f14335615fff9b8c55fccb8971984.svg';
import Abby3 from '!raw-loader!./34a175600dc009a521eb46fdbbbeeb67.svg';
import Abby4 from '!raw-loader!./45de34b47a2ce22f6f5d28bb35a44ff5.svg';

import Box1 from '!raw-loader!./b36584db82bdd45014430aa918461ca0.svg';
import Box2 from '!raw-loader!./b3fc774e753fef520fb544127a48554b.svg';
import Box3 from '!raw-loader!./ded71c8a0f39852178f1695b622c2d89.svg';
import Box4 from '!raw-loader!./d92aaf6cf44921905d51ca4a10a4f3d6.svg';

import Apple from '!raw-loader!./3826a4091a33e4d26f87a2fac7cf796b.svg';

import Arrow1 from '!raw-loader!./be8fcd10da0b082f8d4775088ef7bd52.svg';
import Arrow2 from '!raw-loader!./65b8e977641885010a10a46512fb95b4.svg';
import Arrow3 from '!raw-loader!./dafcdfda65af14e172809984710f31a9.svg';
import Arrow4 from '!raw-loader!./70ffa0bae8693418459f21f370584f6d.svg';

import Avery1 from '!raw-loader!./f52bde34d8027aab14b53f228fe5cc14.svg';
import Avery2 from '!raw-loader!./944385ea927e8f9d72b9e19620487999.svg';

import AveryWalking1 from '!raw-loader!./dc6a584704c09a3fbafb9825635a9fd4.svg';
import AveryWalking2 from '!raw-loader!./448e54fb14b13d492885fc247e76b7f4.svg';
import AveryWalking3 from '!raw-loader!./3a935fe75ac999e22b93d06b3081a271.svg';
import AveryWalking4 from '!raw-loader!./8f439476a738251043d488d7a4bc6870.svg';

import Ball1 from '!raw-loader!./3c6241985b581284ec191f9d1deffde8.svg';
import Ball2 from '!raw-loader!./ad7dc51cafd73e8279073e33b0eab335.svg';
import Ball3 from '!raw-loader!./f221a2edf87aff3615c0c003e616b31b.svg';
import Ball4 from '!raw-loader!./db144b2a19f4f1ab31e30d58f00447dc.svg';
import Ball5 from '!raw-loader!./1c44b7494dec047371f74c705f1d99fc.svg';

import Ballerina1 from '!raw-loader!./5197d3778baf55da6b81b3ada1e10021.svg';
import Ballerina2 from '!raw-loader!./4ccb1752a43f48aafe490c9c08e58c27.svg';
import Ballerina3 from '!raw-loader!./fc02bf591dd3d91eeeb50c7424d08274.svg';
import Ballerina4 from '!raw-loader!./5aae21aee33c3f1ae943af5ea11254bf.svg';

import Balloon1 from '!raw-loader!./d7974f9e15000c16222f94ee32d8227a.svg';
import Balloon2 from '!raw-loader!./a2516ac2b8d7a348194908e630387ea9.svg';
import Balloon3 from '!raw-loader!./63e5aea255610f9fdf0735e1e9a55a5c.svg';

import Bananas from '!raw-loader!./e5d3d3eb61797f5999732a8f5efead24.svg';

import Baseball from '!raw-loader!./74e08fc57820f925c7689e7b754c5848.svg';

import Basketball from '!raw-loader!./6b0b2aaa12d655e96b5b34e92d9fbd4f.svg';

import Bat1 from '!raw-loader!./4e4ced87ed37ee66c758bba077e0eae6.svg';
import Bat2 from '!raw-loader!./bc6dd12fc9e407c7774959cdf427f8b5.svg';
import Bat3 from '!raw-loader!./60f5bfce5d9b11bfcd199a6aa5454b3f.svg';
import Bat4 from '!raw-loader!./698c2a48e774f9959d57c9618b156c20.svg';

import Batter1 from '!raw-loader!./9d193bef6e3d6d8eba6d1470b8bf9351.svg';
import Batter2 from '!raw-loader!./fdfde4bcbaca0f68e83fdf3f4ef0c660.svg';
import Batter3 from '!raw-loader!./bd4fc003528acfa847e45ff82f346eee.svg';
import Batter4 from '!raw-loader!./592ee9ab2aeefe65cb4fb95fcd046f33.svg';

import Beachball from '!raw-loader!./5198b5a03ebae60698e0906f59a5fc15.svg';

import Bear1 from '!raw-loader!./deef1eaa96d550ae6fc11524a1935024.svg';
import Bear2 from '!raw-loader!./6f303e972f33fcb7ef36d0d8012d0975.svg';

import BearWalking1 from '!raw-loader!./6d4d06e3f4cd0c9455b777b9a40782b6.svg';
import BearWalking2 from '!raw-loader!./7453709bef16e33e6f989aee14d7fc07.svg';
import BearWalking3 from '!raw-loader!./6d50c5fe63ab5f77d10144a68ca535a6.svg';
import BearWalking4 from '!raw-loader!./e531b307381c2aa148be4ccc36db0333.svg';
import BearWalking5 from '!raw-loader!./0a38a860f2e573b8dc5b09f390d30fbd.svg';
import BearWalking6 from '!raw-loader!./f36c80d2e731be95df7ec6d07f89fa00.svg';
import BearWalking7 from '!raw-loader!./d2a5f124f988def1d214e6d0813a48f3.svg';
import BearWalking8 from '!raw-loader!./36d06aa23c684fc996952adb0e76e6b4.svg';

import Beetle from '!raw-loader!./46d0dfd4ae7e9bfe3a6a2e35a4905eae.svg';

import Bell from '!raw-loader!./8c0234fe1bfd36f5a72e975fbbc18bfd.svg';

import Ben1 from '!raw-loader!./2cd77b8a9961e7ad4da905e7731b7c1b.svg';
import Ben2 from '!raw-loader!./165d993c30dfdb9e829d0d98867d7826.svg';
import Ben3 from '!raw-loader!./9f9f88aea3457084d8d734040b0b9067.svg';
import Ben4 from '!raw-loader!./acc208e29f0422c2bcffa3b8873abc63.svg';

import Bowl from '!raw-loader!./d147f16e3e2583719c073ac5b55fe3ca.svg';

import Bowtie from '!raw-loader!./4b032ba44b8077439e73815542e7ed23.svg';

import Bread from '!raw-loader!./585de1550446d4420f8a10fdecac995b.svg';

import Broom from '!raw-loader!./556288a1c996345c751a3dc88b570cfa.svg';

import Buildings1 from '!raw-loader!./e8c9508b1f6a0a432e09c10ef9ada67c.svg';
import Buildings2 from '!raw-loader!./a8c977a3b85ffe8c8b453c9d668989b8.svg';
import Buildings3 from '!raw-loader!./e4764cfc384a499f92da3ea745bcebe2.svg';
import Buildings4 from '!raw-loader!./d1fcce0aac589a17324943a3b759fc2a.svg';
import Buildings5 from '!raw-loader!./bb47a3d5d03a34937557c558c6cb5d18.svg';
import Buildings6 from '!raw-loader!./80b120b7152ed72fded84fef485f4f79.svg';
import Buildings7 from '!raw-loader!./4212ff1769c169bfa0db043b18fdade8.svg';
import Buildings8 from '!raw-loader!./8f64966be60d332b345598819c67a8b6.svg';
import Buildings9 from '!raw-loader!./fcedb6b25a2db6de28b39130f978b0bf.svg';
import Buildings10 from '!raw-loader!./148034b1557cc3dae39953e43ab50ff0.svg';

import Butterfly1a from '!raw-loader!./fe98df7367e314d9640bfaa54fc239be.svg';
import Butterfly1b from '!raw-loader!./49c9f952007d870a046cff93b6e5e098.svg';
import Butterfly1c from '!raw-loader!./34b76c1835c6a7fc2c47956e49bb0f52.svg';

import Butterfly2a from '!raw-loader!./372ae0abd2e8e50a20bc12cb160d8746.svg';
import Butterfly2b from '!raw-loader!./e96f4c6913107c9b790d37bb65507c14.svg';

import Button1 from '!raw-loader!./21fb7fa07eac4794fded0be4e18e20a2.svg';

import Button2a from '!raw-loader!./af4cd54e776031bc9cc54ddd6892f97b.svg';
import Button2b from '!raw-loader!./329bf3d86050ceaea2b27e2c5d2baec1.svg';

import Button3a from '!raw-loader!./5021f6b7d166873ef0711c4d4a351912.svg';
import Button3b from '!raw-loader!./a3b357ea21773bcb3545a227ee877e9a.svg';

import Button4a from '!raw-loader!./71ced7c192168c7b221d16b4eaff440e.svg';
import Button4b from '!raw-loader!./7d34ad26633abbc752c9cd93ace0a81f.svg';

import Button5a from '!raw-loader!./94957f2f79e8970d8b2cd0f74a0c1ffc.svg';
import Button5b from '!raw-loader!./a4bb9a9e06e65337798471035719985a.svg';

import Cake1 from '!raw-loader!./862488bf66b67c5330cae9235b853b6e.svg';
import Cake2 from '!raw-loader!./dfe9c5d40da0dcc386fad524c36d3579.svg';

import Casey1 from '!raw-loader!./e5a47371f3e9f853b36560cda35344b6.svg';
import Casey2 from '!raw-loader!./e09e5ef2bdeb69163a543f3216c1f54c.svg';
import Casey3 from '!raw-loader!./50bd5162671b8a30fcfa3082a9e79ec4.svg';
import Casey4 from '!raw-loader!./ebc3de539e02801d420268eb189c5a47.svg';

import Mino1 from '!raw-loader!./7499cf6ec438d0c7af6f896bc6adc294.svg';
import Mino2 from '!raw-loader!./a1ab94c8172c3b97ed9a2bf7c32172cd.svg';
import Mino3 from '!raw-loader!./6667936a2793aade66c765c329379ad0.svg';

import Catcher1 from '!raw-loader!./895cdda4f2bd9d6f50ff07188e7ce395.svg';
import Catcher2 from '!raw-loader!./a31e30677637ae4de975d40b6d822853.svg';
import Catcher3 from '!raw-loader!./99af13802e9bfd7b4a4bfb8ead825c0c.svg';
import Catcher4 from '!raw-loader!./8aa875f077c405e2045f5ab60705e712.svg';

import Centaur1 from '!raw-loader!./d722329bd9373ad80625e5be6d52f3ed.svg';
import Centaur2 from '!raw-loader!./2373556e776cad3ba4d6ee04fc34550b.svg';
import Centaur3 from '!raw-loader!./d7aa990538915b7ef1f496d7e8486ade.svg';
import Centaur4 from '!raw-loader!./c00ffa6c5dd0baf9f456b897ff974377.svg';

import Character1a from '!raw-loader!./03bc23a9fa12c1244c83a07a81f20bfd.svg';
import Character1b from '!raw-loader!./f26b130c2c58b812be21d1a9745863a1.svg';
import Character1c from '!raw-loader!./cc0be722cf93eef63726bd606ab11c5c.svg';
import Character1d from '!raw-loader!./6be261800647c53becb1f93ed31ed13e.svg';
import Character1e from '!raw-loader!./6f78ce6a87d114162ed9fbef30f9a0fd.svg';
import Character1f from '!raw-loader!./527ba82c5e82f43c8fca0be905dbe20a.svg';
import Character1g from '!raw-loader!./1e303bb57aac0cb4678e85de4251f3f4.svg';
import Character1h from '!raw-loader!./0f18f9e90d0ed68ebec23da087eb2603.svg';
import Character1i from '!raw-loader!./5e2f620e5687a36e1954414054c69ccc.svg';
import Character1j from '!raw-loader!./1044a68cc743f83564e36a6bca16830b.svg';
import Character1k from '!raw-loader!./b37d0e0d46f07cb2cbdc5285e176bf62.svg';
import Character1l from '!raw-loader!./984043e1e7c544999c31f952d1d43a56.svg';
import Character1m from '!raw-loader!./6d5ddfc69f9c6a3f1d2ded1428237931.svg';

import Character2a from '!raw-loader!./7084b3baab935de819cc5ab46f7cecf8.svg';
import Character2b from '!raw-loader!./df7cbf2913bcea721df2e0360644f193.svg';
import Character2c from '!raw-loader!./e0eacf1e575adc559c41e3a81a892168.svg';
import Character2d from '!raw-loader!./e8b44b0e904fd4bb7430c26b743f1520.svg';
import Character2e from '!raw-loader!./67d425b11544caa0fe9228f355c6485b.svg';
import Character2f from '!raw-loader!./db3f436fcb6fb28828a4c932b60feb5e.svg';
import Character2g from '!raw-loader!./93e035270675f933b94ee951d7e475e3.svg';
import Character2h from '!raw-loader!./f4f2778df2840de5a6449a49f3efb599.svg';
import Character2i from '!raw-loader!./1cf73a791959e07b5bafe18474f93b78.svg';
import Character2j from '!raw-loader!./bf0d808f7bf0c11c338b4fea0a735874.svg';

import Chick1 from '!raw-loader!./80abbc427366bca477ccf1ef0faf240a.svg';
import Chick2 from '!raw-loader!./5e23c8c28ffd390df7deb2414be37781.svg';
import Chick3 from '!raw-loader!./77911bbe5e11ede35871e8002a26356d.svg';

import CityBus1 from '!raw-loader!./e9694adbff9422363e2ea03166015393.svg';
import CityBus2 from '!raw-loader!./7d7e26014a346b894db8ab1819f2167f.svg';

import Cloud1 from '!raw-loader!./c9630e30e59e4565e785a26f58568904.svg';
import Cloud2 from '!raw-loader!./9f5958f46d21e33d3f6d7caffbe0daa9.svg';
import Cloud3 from '!raw-loader!./9105d7dd90b5f2a4b85a1e71aff8703f.svg';
import Cloud4 from '!raw-loader!./0188b2c7c85176b462881c6bca7a7748.svg';
import Cloud5 from '!raw-loader!./9f2eccce13e3e5fd212efd59ff1d96a0.svg';

import Convertible3 from '!raw-loader!./621817ef84ad81f5690fac95adab2ede.svg';

import Crab1 from '!raw-loader!./f7cdd2acbc6d7559d33be8675059c79e.svg';
import Crab2 from '!raw-loader!./49839aa1b0feed02a3c759db5f8dee71.svg';

import Crystal1 from '!raw-loader!./ecd1e7805b37db4caf207b7eef2b7a42.svg';
import Crystal2 from '!raw-loader!./0a7b872042cecaf30cc154c0144f002b.svg';

import Dani1 from '!raw-loader!./6518333c95cf96a9aaf73a4a948e002f.svg';
import Dani2 from '!raw-loader!./2cba86439098a7e0daa46e0ff8a59f7c.svg';
import Dani3 from '!raw-loader!./0a7b872042cecaf30cc154c0144f002b.svg';

import Dee1 from '!raw-loader!./43bd4c241a94b3aea883472d7dab5afc.svg';
import Dee2 from '!raw-loader!./e4c6ada3509f7033d14bac2c0eea49dc.svg';
import Dee3 from '!raw-loader!./1de3bbee2771b0ff16c4658d5ad98b0b.svg';
import Dee4 from '!raw-loader!./320a892c86e9b039ba9d6d50a4897276.svg';
import Dee5 from '!raw-loader!./c57c4593701165cdea6de9b014c7c06d.svg';

import Devin1 from '!raw-loader!./5f614017dba0ce6bff063f6c62041035.svg';
import Devin2 from '!raw-loader!./9d7414a719d6cc5e0e9071ede200a29c.svg';
import Devin3 from '!raw-loader!./5ab51aeaa296e955e75a7a3c103ebb99.svg';
import Devin4 from '!raw-loader!./bfc7c20b64f86d4b207780f3da695fa4.svg';

import Dinosaur1a from '!raw-loader!./45b02fbd582c15a50e1953830b59b377.svg';
import Dinosaur1b from '!raw-loader!./7f89417968116ada83d4ddaad22403b3.svg';
import Dinosaur1c from '!raw-loader!./22d94ee5daf557284465425a61186234.svg';
import Dinosaur1d from '!raw-loader!./af158d368bf3da576369be1130e18acd.svg';

import Dinosaur2a from '!raw-loader!./7799f2848136d11f48ca5f3105d336ef.svg';
import Dinosaur2b from '!raw-loader!./d926c5758d130fcfd9a7ae7dac47e47d.svg';
import Dinosaur2c from '!raw-loader!./0e43f8e573bf232505b207b92efac2ac.svg';
import Dinosaur2d from '!raw-loader!./e606ba27dfe94daf3d8e3fdf599e37cf.svg';

import Dinosaur3a from '!raw-loader!./d85ec1b97f73564ef26fec73d5056c68.svg';
import Dinosaur3b from '!raw-loader!./e731d1f1ebf4bc0ea55b850ffe5a5f96.svg';
import Dinosaur3c from '!raw-loader!./ae98efa1c3c3700602e1344db86aaf72.svg';
import Dinosaur3d from '!raw-loader!./cf4fb77a4e9839f83d3fa5fc0982ccd3.svg';
import Dinosaur3e from '!raw-loader!./5381feb0fc1b50ddc2793342daddffef.svg';

import Dinosaur4a from '!raw-loader!./a98e3f93853513e7c00bab4c61752312.svg';
import Dinosaur4b from '!raw-loader!./ac99ef62e3e018b8db550bb2a187cbe9.svg';
import Dinosaur4c from '!raw-loader!./c63cca929380152b978d8671fe6003f7.svg';
import Dinosaur4d from '!raw-loader!./723bd1559f8baae4184fa24a6513362b.svg';

import Diver1 from '!raw-loader!./a24f23a0f5d77cfb59721ef8f6bfe5c7.svg';
import Diver2 from '!raw-loader!./ef8136a42b7d20961756e551bc87b37f.svg';

import Dog1a from '!raw-loader!./35cd78a8a71546a16c530d0b2d7d5a7f.svg';
import Dog1b from '!raw-loader!./d5a72e1eb23a91df4b53c0b16493d1e6.svg';

import Dog2a from '!raw-loader!./66b435d333f34d02d5ae49a598bcc5b3.svg';
import Dog2b from '!raw-loader!./6afc06388d69f99e28d883126f9b2734.svg';
import Dog2c from '!raw-loader!./4708bff29b3a295a03ac1d5e2d16ec75.svg';

import Donut from '!raw-loader!./316a67c9e966fd015b4538f54be456db.svg';

import Dorian1 from '!raw-loader!./a9a064a1f28c9e22b594dcea1d46025b.svg';
import Dorian2 from '!raw-loader!./7d20ec98603857c031c1f4ad2bd8ea51.svg';
import Dorian3 from '!raw-loader!./8f2be2387efcbb5d4878886adaa2a88e.svg';
import Dorian4 from '!raw-loader!./603d3dd151984c0eaa2822f70a234c28.svg';

import Dot1 from '!raw-loader!./106461f60e34ce231b323e2dd2d9f05b.svg';
import Dot2 from '!raw-loader!./21482022f9930400302bc8ec70643717.svg';
import Dot3 from '!raw-loader!./9e5a6cc6970ce4932a09affba70a45b0.svg';
import Dot4 from '!raw-loader!./fb047c94113ee4c6664305a338525e6a.svg';

import Dove1 from '!raw-loader!./0f83ab55012a7affd94e38250d55a0a0.svg';
import Dove2 from '!raw-loader!./778a699a044a0a8c10f44c3194e21ef2.svg';

import Dragon1 from '!raw-loader!./12ead885460d96a19132e5970839d36d.svg';
import Dragon2 from '!raw-loader!./3f672475ad4ca5d1f9331cffd4223140.svg';
import Dragon3 from '!raw-loader!./e0aa0083fa0b97da97600d4dbb2055e5.svg';

import Dragonfly1 from '!raw-loader!./5cdfe67af929e3fb095e83c9c4b0bd78.svg';
import Dragonfly2 from '!raw-loader!./17b864c1ddd4b349a6c4bd5709167307.svg';

import Dress1 from '!raw-loader!./ddbea537af6012ebac18d16d65c07479.svg';
import Dress2 from '!raw-loader!./4e22e6fd72500f0a25b959283bfd0a32.svg';
import Dress3 from '!raw-loader!./c5fb135d89573570010b0d96c94bcec6.svg';

import Drum1 from '!raw-loader!./ce6971317035091341ec40571c9056e9.svg';
import Drum2 from '!raw-loader!./47531b5675be696d0540eb120d5d0678.svg';

import DrumKit1 from '!raw-loader!./baf6344b6f55b074786a383c1097697d.svg';
import DrumKit2 from '!raw-loader!./3f4fb4836338c55f883607c403b2b25e.svg';

import DrumCymbal1 from '!raw-loader!./78398692e6fa226568df0374c4358da4.svg';
import DrumCymbal2 from '!raw-loader!./08355ec8cc4b3263f502adfdea993cda.svg';

import DrumHighhat1 from '!raw-loader!./15b2a31a57d0cd911ad0b1c265dcf59e.svg';
import DrumHighhat2 from '!raw-loader!./866b3a49ee2a45998940e2d737c4c502.svg';

import DrumSnare1 from '!raw-loader!./c42bb05aab3cacddcd88712e33ab8df0.svg';
import DrumSnare2 from '!raw-loader!./28298d93f5282041267a92bd67308107.svg';

import DrumsConga1 from '!raw-loader!./2b2eacfce0fb1af023e6ca0f5ef6defe.svg';
import DrumsConga2 from '!raw-loader!./bdad2f140cfbd021f38241fc9acc7fd2.svg';

import DrumsTabla1 from '!raw-loader!./af071d9d714c5c622e2bb07133698ce3.svg';
import DrumsTabla2 from '!raw-loader!./992d6359be830d977559dad91b04f698.svg';

import Duck from '!raw-loader!./c9837d0454f5f0f73df290af2045359b.svg';

import Earth from '!raw-loader!./7405b5efa96995bae6853667f8cd145e.svg';

import Easel1 from '!raw-loader!./a4b3714322c11b350f09a75921ae606b.svg';
import Easel2 from '!raw-loader!./6a736beddc7844538be390c18b7c4361.svg';
import Easel3 from '!raw-loader!./caec09682a7fcdffef4647e8355ba004.svg';

import Egg1 from '!raw-loader!./f8ee449298c1446cb0ef281923a4e57a.svg';
import Egg2 from '!raw-loader!./fbc629c3b062423e8c09cfacfb1e65f8.svg';
import Egg3 from '!raw-loader!./0d127490af16f8a4ca5ce3212b2391c2.svg';
import Egg4 from '!raw-loader!./b0b6e88ec64b842398200bab562b53e3.svg';
import Egg5 from '!raw-loader!./41535b4742f40e2630746b0c4bec98f2.svg';
import Egg6 from '!raw-loader!./bb0505b802140a8cc200c9f8bfce4503.svg';

import Elephant1 from '!raw-loader!./b59873e9558c1c456200f50e5ab34770.svg';
import Elephant2 from '!raw-loader!./2c9b5e0125d95b8bc511f6bb09b5ea2f.svg';

import Elf1 from '!raw-loader!./e92abad171396a3198455df8557802e5.svg';
import Elf2 from '!raw-loader!./92ff640b911a8348d2734c0e38bba68c.svg';
import Elf3 from '!raw-loader!./524406c2b1fe253c1565ff516309817e.svg';
import Elf4 from '!raw-loader!./808c6fa2eb1cba0de1d17b18c6f41279.svg';
import Elf5 from '!raw-loader!./ec458328a85f89f06866e2337076ac0a.svg';

import Fairy1 from '!raw-loader!./40d726e17bfd2ffeb8c0aa5393ee1c77.svg';
import Fairy2 from '!raw-loader!./bea920473027f43e04c44e588c6cc39a.svg';
import Fairy3 from '!raw-loader!./d4f6163a1610243f55dd9cf1c9875c61.svg';
import Fairy4 from '!raw-loader!./902350bba0d4b4612db1e2e902b6f201.svg';
import Fairy5 from '!raw-loader!./decd31f829032b1d4dcf5efdbd362cb9.svg';

import Fish1 from '!raw-loader!./a9b3d163756621f8395592ad77fb9369.svg';
import Fish2 from '!raw-loader!./7a0c31c0087f342867d4754f8dc57541.svg';
import Fish3 from '!raw-loader!./4a3478b3cdc3e8688a671be88c2775fd.svg';
import Fish4 from '!raw-loader!./886e0bb732453eb8d3a849b4eab54943.svg';

import Fishbowl1 from '!raw-loader!./17c53cf0296f24722ba5b001d513e58f.svg';
import Fishbowl2 from '!raw-loader!./b3db01c5cda32fe3ea0b48dde5fa8130.svg';

import FoodTruck1 from '!raw-loader!./a77f9693f87288d023a4632cf019776e.svg';
import FoodTruck2 from '!raw-loader!./f4150de2297a63c3efd125c8e12dd7cc.svg';
import FoodTruck3 from '!raw-loader!./e850e3c93de767519f7f78b38f16ed1d.svg';

import Fox1 from '!raw-loader!./9dd59a4514b5373d4f665db78e145636.svg';
import Fox2 from '!raw-loader!./2c256eacbb753be361e8e52a0eefde77.svg';
import Fox3 from '!raw-loader!./dd398ed81edb60c91ad4805f4437d2fa.svg';

import Frank1 from '!raw-loader!./10d39bb7e31647a465e747cd243b8cd0.svg';
import Frank2 from '!raw-loader!./e56e930cc0229d1042a673e7503209c5.svg';
import Frank3 from '!raw-loader!./26da9617218493f4f42a1592f21afee8.svg';
import Frank4 from '!raw-loader!./d16b76a634f7367ce7d6112401a78e57.svg';

import Frog from '!raw-loader!./390845c11df0924f3b627bafeb3f814e.svg';
import Frog1 from '!raw-loader!./f2246c13e4540472c484119bc314d954.svg';
import Frog2 from '!raw-loader!./d9f69469090784d8dd68d94c0fd78a50.svg';
import Frog3 from '!raw-loader!./0717f446c991aac7df2fe4d6590354e7.svg';

import FruitSalad from '!raw-loader!./2e6ef315101433b78e38719e8cc630c2.svg';

import Ghost1 from '!raw-loader!./f522b08c5757569ad289d67bce290cd0.svg';
import Ghost2 from '!raw-loader!./d1d89391f1d9c74557e504456d58a002.svg';
import Ghost3 from '!raw-loader!./634744e3f98bee53e9cb477a63aa9b21.svg';
import Ghost4 from '!raw-loader!./40ba3a0b5b3899a655fd8867229d4ee3.svg';

import Gift1 from '!raw-loader!./0fdd104de718c5fc4a65da429468bdbd.svg';
import Gift2 from '!raw-loader!./6cbeda5d391c6d107f0b853222f344d9.svg';
import Giga1 from '!raw-loader!./92161a11e851ecda94cbbb985018fed6.svg';
import Giga2 from '!raw-loader!./bc706a7648342aaacac9050378b40c43.svg';
import Giga3 from '!raw-loader!./337b338b2b10176221e638ac537854e6.svg';
import Giga4 from '!raw-loader!./db15886cfdcb5e2f4459e9074e3990a1.svg';

import GigaWalking1 from '!raw-loader!./3afad833094d8dff1c4ff79edcaa13d0.svg';
import GigaWalking2 from '!raw-loader!./d27716e022fb5f747d7b09fe6eeeca06.svg';
import GigaWalking3 from '!raw-loader!./db55131bf54f96e8986d9b30730e42ce.svg';

import Giraffe1 from '!raw-loader!./43e89629fb9df7051eaf307c695424fc.svg';
import Giraffe2 from '!raw-loader!./ef1fca2ae13d49d9dd2c6cfc211a687c.svg';
import Giraffe3 from '!raw-loader!./cfd93a103479993aee4d680655e39d8d.svg';

import GlassWater1 from '!raw-loader!./cbf21cf1b057852f91135d27ebbf11ce.svg';
import GlassWater2 from '!raw-loader!./ca70c69ef1f797d353581a3f76116ae3.svg';

import Glasses1 from '!raw-loader!./705035328ac53d5ce1aa5a1ed1c2d172.svg';
import Glasses2 from '!raw-loader!./f2a02d0e7431147b8a4a282e02a8e6a4.svg';
import Glasses3 from '!raw-loader!./9e2f75d3a09f3f10d554ba8380c3ae52.svg';
import Glasses4 from '!raw-loader!./acd85b36e6b8d93ba4194ee2ea334207.svg';

import Goalie1 from '!raw-loader!./a554f2a9b49a09ec67d1fd7ecfbcddcd.svg';
import Goalie2 from '!raw-loader!./59eedd0a23c3c983d386a0c125991c7f.svg';
import Goalie3 from '!raw-loader!./f2e7ba53f3a28c4359cb0d3e3cb4001a.svg';
import Goalie4 from '!raw-loader!./63f2955298d59dd22dc7b7c6a9c521e2.svg';
import Goalie5 from '!raw-loader!./eb096e2b4234f5f8ee1f2c44429eaa1a.svg';

import Goblin1 from '!raw-loader!./3f08380f25062b8055a1800f5dad14bd.svg';
import Goblin2 from '!raw-loader!./b8604b8039d6b633015aaf17d74d5d5b.svg';
import Goblin3 from '!raw-loader!./2add9ef4eaa25f8915406dcfd8bafc9f.svg';
import Goblin4 from '!raw-loader!./afb9fe328adae617ee3375366fca02e7.svg';

import Grasshopper1 from '!raw-loader!./e7210a370837dd1e4ebc1a56a973b7f6.svg';
import Grasshopper2 from '!raw-loader!./529644c5ecdca63adafd87777e341ad7.svg';
import Grasshopper3 from '!raw-loader!./cf2ac769df444137b4c1eec472fa4b92.svg';
import Grasshopper4 from '!raw-loader!./a7c638b8aa86f2a758830f8c2b0e4cf5.svg';
import Grasshopper5 from '!raw-loader!./d4f3dfe69be6537e73544381408a820d.svg';
import Grasshopper6 from '!raw-loader!./93550d8abde130ad149904c4448f8b65.svg';

import GreenFlag from '!raw-loader!./2bbfd072183a67db5eddb923fe0726b3.svg';

import Griffin1 from '!raw-loader!./a31166d45903206b52cb0f0a0cb687b5.svg';
import Griffin2 from '!raw-loader!./102f6200c13bd60afa9538c712776fb0.svg';
import Griffin3 from '!raw-loader!./157d3665cebcd41fa814b9217af99476.svg';
import Griffin4 from '!raw-loader!./b8c8745820a341afec08e77f4a254551.svg';

import Hare1 from '!raw-loader!./7269593d83b6f9eae512997f541a7417.svg';
import Hare2 from '!raw-loader!./c8dbb4302dd489a201938c203018c2f0.svg';
import Hare3 from '!raw-loader!./85a3b8c151e10576fa531a4293fdac00.svg';

import Harper1 from '!raw-loader!./3a0973a042ee16e816c568651316d5d4.svg';
import Harper2 from '!raw-loader!./e407fa0ed992393d12d0a108c11e2fa6.svg';
import Harper3 from '!raw-loader!./98ce6e6bb99f8ba116f127fdf2e739fd.svg';

import Hat1 from '!raw-loader!./c632719725400c604fcadf0858ce2b2c.svg';
import Hat2 from '!raw-loader!./0aed53a86d92ec2283068000ac97a60b.svg';
import Hat3 from '!raw-loader!./13e382ae3f05a9a23e0b64ca23230438.svg';
import Hat4 from '!raw-loader!./6349e36da9897a2f89bdbf5c77dbdacb.svg';

import Hatchling1 from '!raw-loader!./55f7d457eb0af78cb309ca47497c490f.svg';
import Hatchling2 from '!raw-loader!./0e5c295a043d5e183a98046e4f734b72.svg';
import Hatchling3 from '!raw-loader!./f27d557be70a9522fae4392bfd4f5249.svg';

import Heart1 from '!raw-loader!./c77e640f6e023e7ce1e376da0f26e1eb.svg';
import Heart2 from '!raw-loader!./e24731f5cf2759c2f289921bebb86ea2.svg';

import HeartCandy1 from '!raw-loader!./288976865e8c5db717d859e915606d82.svg';
import HeartCandy2 from '!raw-loader!./51248e76be2aa7a0f0ed77bc94af1b3a.svg';
import HeartCandy3 from '!raw-loader!./3ee430ba825f41ae9913453d4932fb8b.svg';
import HeartCandy4 from '!raw-loader!./5fa8c4693cf8cba8cdbcbed72f4f58aa.svg';

import HeartFace from '!raw-loader!./989770846f8cd1628b48bbe91d0a7d0d.svg';

import Hedgehog1 from '!raw-loader!./3b0e1717859808cecf1a45e2a32dc201.svg';
import Hedgehog2 from '!raw-loader!./42bac40ca828133600e0a9f7ba019adb.svg';
import Hedgehog3 from '!raw-loader!./3251533232e7f44315512149c7f76214.svg';
import Hedgehog4 from '!raw-loader!./93c2d7a0abefaf26ee50d5038ac5bf61.svg';
import Hedgehog5 from '!raw-loader!./1fcbba4a2252e96c52d2d8aa8e593e51.svg';

import Hen1 from '!raw-loader!./b02a33e32313cc9a75781a6fafd07033.svg';
import Hen2 from '!raw-loader!./d055896a473bb12f4ec67af1fdb9c652.svg';
import Hen3 from '!raw-loader!./c9a4570a2d0ae09b9feeeb5607e4b9c7.svg';
import Hen4 from '!raw-loader!./6c9e05f568862dbcea0a1652a210239b.svg';

import Hippo1 from '!raw-loader!./911901dc568b56c15fe81819bc2af653.svg';
import Hippo2 from '!raw-loader!./5764a2c650f225bc27cc0e6c5db401ea.svg';

import HomeButton from '!raw-loader!./1ebdcb9f033fa6658259b52da376b7ac.svg';

import Horse1 from '!raw-loader!./ad458251c5bf5b375870829f1762fa47.svg';
import Horse2 from '!raw-loader!./0e0fa871bea01c2dfb70e9955dc098be.svg';

import Jamal1 from '!raw-loader!./3c8d5e688450ad1e6bf024a32c55bcda.svg';
import Jamal2 from '!raw-loader!./2408318e743873c7254db1623441b9c5.svg';
import Jamal3 from '!raw-loader!./693748d763c8da4b119a5e4bee6a1768.svg';
import Jamal4 from '!raw-loader!./92692e0c0f376797274392484ba74133.svg';

import Jar1 from '!raw-loader!./33b537168f3c2eb3dafeb739c22f38a6.svg';
import Jar2 from '!raw-loader!./e0f5ac773987470ff2467e3e01b9ab23.svg';

import Jellyfish1 from '!raw-loader!./db4d97cbf24e2b8af665bfbf06f67fa0.svg';
import Jellyfish2 from '!raw-loader!./a7cc1e5f02b58ecc8095cfc18eef0289.svg';
import Jellyfish3 from '!raw-loader!./768c4601174f0dfcb96b3080ccc3a192.svg';
import Jellyfish4 from '!raw-loader!./00c8c464c19460df693f8d5ae69afdab.svg';

import Jordyn1 from '!raw-loader!./4e259b7c08f05145fc7800b33e4f356e.svg';
import Jordyn2 from '!raw-loader!./5944a1e687fa31589517825b2144a17b.svg';
import Jordyn3 from '!raw-loader!./00c99df84f8385038461d6c42a5465ab.svg';
import Jordyn4 from '!raw-loader!./3158299771b3d34ed2c50a00fbab715e.svg';

import Key from '!raw-loader!./680d3e4dce002f922b32447fcf29743d.svg';

import Keyboard1 from '!raw-loader!./0ad880b5e829578832c8927b3f6ef7f8.svg';
import Keyboard2 from '!raw-loader!./6efd23c91dab070526feacdf72e2d3da.svg';

import Kia1 from '!raw-loader!./e56e480c994572323d88355b8733e1a3.svg';
import Kia2 from '!raw-loader!./b3d0a248adbc26b0d0826e042a81670a.svg';
import Kia3 from '!raw-loader!./db6cd6b145bb6d8dc299475af7423d6e.svg';

import Kiran1 from '!raw-loader!./7c0bedab5404830a5147cc4a2d46e997.svg';
import Kiran2 from '!raw-loader!./b0566e0eed7b5216b92d61468d21ecee.svg';
import Kiran3 from '!raw-loader!./78bd6de23d4929aef678ddf0f3f5c276.svg';
import Kiran4 from '!raw-loader!./2928e9fbd5ca08e326192b3a41bea691.svg';
import Kiran5 from '!raw-loader!./7912b6f378bd781f62683e003c574dbe.svg';
import Kiran6 from '!raw-loader!./7f0bc123819fc2666321b6cd38069bdb.svg';

import Knight from '!raw-loader!./188325c56b79ff3cd58497c970ba87a6.svg';

import Ladybug1 from '!raw-loader!./169c0efa8c094fdedddf8c19c36f0229.svg';
import Ladybug2a from '!raw-loader!./457200f8dec8fea00d22473e9bd9175e.svg';
import Ladybug2b from '!raw-loader!./3f48228829b77fc47d6d89b5729b2957.svg';

import Lightning from '!raw-loader!./0ddd3a05a330925bcd2d048908ed40b8.svg';

import Line from '!raw-loader!./e85305b47cfd92d971704dcb7ad6e17b.svg';

import Lion1 from '!raw-loader!./e88e83c8b3ca80c54540b5f0c5a0cc03.svg';
import Lion2 from '!raw-loader!./f0d9ab3d82bbade6e279dc1c81e2e6db.svg';
import Lion3 from '!raw-loader!./91c64c5361d906fd36d5813ae27b85a8.svg';

import Monkey1 from '!raw-loader!./254926ee81bfa82f2db7009a80635061.svg';
import Monkey2 from '!raw-loader!./de0405b0576ade1282bdfcd198922baa.svg';
import Monkey3 from '!raw-loader!./ec6d62f0ff64bb5440ffdc662b6e46fa.svg';

import Nano1 from '!raw-loader!./a62e560863c0e49b12e5d57e13d084f1.svg';
import Nano2 from '!raw-loader!./d12aead3e3c2917e7eba8b2b90a7afd2.svg';
import Nano3 from '!raw-loader!./8f2f4a70e87262ef478ce60567b6208a.svg';
import Nano4 from '!raw-loader!./a4e2034751fa650fd5fd69432c110104.svg';

import NeighPony from '!raw-loader!./592816f56409d582603c485cbefcbbb8.svg';

import Parrot1 from '!raw-loader!./082f371c206f07d20e53595a9c69cc22.svg';
import Parrot2 from '!raw-loader!./036fad20b674197358f8c0b2dc64e17e.svg';

import Penguin1 from '!raw-loader!./428772307d90f4b347d6cc3c0d8e76ef.svg';
import Penguin2 from '!raw-loader!./d485f5620d2dde69a6aa1cda7c897d12.svg';
import Penguin3 from '!raw-loader!./280d2aa13f0c6774cc8828dc177aaf60.svg';
import Penguin4 from '!raw-loader!./780467f3d173dcb37fd65834841babc6.svg';

import Pico1 from '!raw-loader!./e7ce31db37f7abd2901499db2e9ad83a.svg';
import Pico2 from '!raw-loader!./a7597b1f0c13455d335a3d4fe77da528.svg';
import Pico3 from '!raw-loader!./bcc0e8a5dda3a813608902b887c87bb4.svg';
import Pico4 from '!raw-loader!./d6dfa2efe58939af4c85755feb3c0375.svg';

import PicoWalking1 from '!raw-loader!./c8f58f31cabf4acabb3f828730061276.svg';
import PicoWalking2 from '!raw-loader!./52a60eccb624530fd3a24fc41fbad6e5.svg';
import PicoWalking3 from '!raw-loader!./702bd644d01ea8eda2ea122daeea7d74.svg';
import PicoWalking4 from '!raw-loader!./22fb16ae7cc18187a7adaf2852f07884.svg';

import RetroRobot1 from '!raw-loader!./35070c1078c4eec153ea2769516c922c.svg';
import RetroRobot2 from '!raw-loader!./d139f89665962dcaab4cb2b246359ba1.svg';
import RetroRobot3 from '!raw-loader!./53398a713b144ecda6ec32fb4a8d28e1.svg';


import Robot1 from '!raw-loader!./89679608327ad572b93225d06fe9edda.svg';
import Robot2 from '!raw-loader!./36d1098b880dbe47e58d93e7b2842381.svg';
import Robot3 from '!raw-loader!./4f5441207afc9bc075b0b404dbba8b59.svg';
import Robot4 from '!raw-loader!./10060b3b58c77345cfe92288a46e5c20.svg';

import Rocketship1 from '!raw-loader!./525c06ceb3a351244bcd810c9ba951c7.svg';
import Rocketship2 from '!raw-loader!./10f83786e5ee34f40ee43b49bba89ee2.svg';
import Rocketship3 from '!raw-loader!./a6ff2f1344a18cc0a4bcc945e00afaf4.svg';
import Rocketship4 from '!raw-loader!./5682c68af2cc8aea791f0373e9ed03d8.svg';
import Rocketship5 from '!raw-loader!./49ee475c516a444d8a512724063b8b98.svg';

import Rocks from '!raw-loader!./0ae345deb1c81ec7f4f4644c26ac85fa.svg';

// Background
import Baseball1 from '!raw-loader!./825d9b54682c406215d9d1f98a819449.svg';
import Baseball2 from '!raw-loader!./7be1f5b3e682813dac1f297e52ff7dca.svg';
import Basketball1 from '!raw-loader!./ae21eac3d1814aee1d37ae82ea287816.svg';
import BlueSky1 from '!raw-loader!./e7c147730f19d284bcd7b3f00af19bb6.svg';
import BlueSky2 from '!raw-loader!./8eb8790be5507fdccf73e7c1570bbbab.svg';
import Circles from '!raw-loader!./c9847be305920807c5597d81576dd0c4.svg';
import Hearts from '!raw-loader!./f98526ccb0eec3ac7d6c8f8ab502825e.svg';
import Jurassic from '!raw-loader!./64025bdca5db4938f65597e3682fddcf.svg';
import Light from '!raw-loader!./4b98c07876ed8997c3762e75790507b4.svg';
import Party from '!raw-loader!./108160d0e44d1c340182e31c9dc0758a.svg';
import Rays from '!raw-loader!./87e963282db9e020e8c4d075891ea12b.svg';
import Refrigerator from '!raw-loader!./98f053f9681e872f34fafd783ce72205.svg';
import Stripes from '!raw-loader!./a6a21f5c08d586e8daaebde37c97fb6f.svg';
import Underwater1 from '!raw-loader!./d3344650f594bcecdf46aa4a9441badd.svg';
import Winter from '!raw-loader!./5fa9385a60b904672d0e46e9d768bb32.svg';
import Woods from '!raw-loader!./f3eb165d6f3fd23370f97079f2e631bf.svg';

/* eslint-enable import/no-unresolved */

const defaultProject = translator => {
    let _TextEncoder;
    if (typeof TextEncoder === 'undefined') {
        _TextEncoder = require('text-encoding').TextEncoder;
    } else {
        /* global TextEncoder */
        _TextEncoder = TextEncoder;
    }
    const encoder = new _TextEncoder();

    const projectJson = projectData(translator);
    return [{
        id: 0,
        assetType: 'Project',
        dataFormat: 'JSON',
        data: JSON.stringify(projectJson)
    }, {
        id: '83a9787d4cb6f3b7632b4ddfebf74367',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(popWav)
    }, {
        id: '83c36d806dc92327b9e7049a565c6bff',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(meowWav)
    }, {
        id: 'cd21514d0531fdffb22204e0ec5ed84a',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(backdrop)
    },

    //  Sounds  //
    {
        id: '1727f65b5f22d151685b8e5917456a60',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(BasketballBounce)
    },
    {
        id: '0b1e3033140d094563248e61de4039e5',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(Chomp)
    },
    {
        id: '53a3c2e27d1fb5fdb14aaf0cb41e7889',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(Boing)
    },
    {
        id: '0039635b1d6853face36581784558454',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(Bite)
    },
    {
        id: 'e8b6d605f5a1bb36c29e4e21ef754209',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(Owl)
    },
    {
        id: '6ac484e97c1c1fe1384642e26a125e70',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(Xylo1)
    },
    {
        id: '25d61e79cbeba4041eebeaebd7bf9598',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(BellToll)
    },
    {
        id: 'a434069c58e79d42f5d21abb1c318919',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(GoalCheer)
    },
    {
        id: '8468b9b3f11a665ee4d215afd8463b97',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(RefereeWhistle)
    },
    {
        id: '89691587a169d935a58c48c3d4e78534',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(Birthday)
    },
    {
        id: 'cf51a0c4088942d95bcc20af13202710',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(Meow2)
    },
    {
        id: '362d7440a57cab29914fecea621e50d4',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(Snort)
    },
    {
        id: '3b8236bbb288019d93ae38362e865972',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(Chirp)
    },
    {
        id: 'ec66961f188e9b8a9c75771db744d096',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(ClownHonk)
    },
    {
        id: 'ead1da4a87ff6cb53441142f7ac37b8f',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(CarVroom)
    },
    {
        id: '1cb60ecdb1075c8769cb346d5c2a22c7',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(MagicSpell)
    },
    {
        id: '32514c51e03db680e9c63857b840ae78',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(Collect)
    },
    {
        id: 'b15adefc3c12f758b6dc6a045362532f',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(Dog1)
    },
    {
        id: 'cd8fa8390b0efdd281882533fbfcfcfb',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(Bark)
    },
    {
        id: '18bd4b634a3f992a16b30344c7d810e0',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(Bird)
    },
    {
        id: 'd623f99b3c8d33932eb2c6c9cfd817c5',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(HighTom)
    },
    {
        id: '1569bbbd8952b0575e5a5cb5aefb50ba',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(LowTom)
    },
    {
        id: '48328c874353617451e4c7902cc82817',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(DrumBass1)
    },  
    {
        id: '711a1270d1cf2e5de9b145ee539213e4',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(DrumBass2)
    },   
    {
        id: 'c21704337b16359ea631b5f8eb48f765',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(DrumBass3)
    }, 
    {
        id: 'f2c47a46f614f467a7ac802ed9ec3d8e',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(CrashCymbal)
    },
    {
        id: '9d63ed5be96c43b06492e8b4a9cea8d8',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(SplashCymbal)
    }, 
    {
        id: 'efddec047de95492f775a1b5b2e8d19e',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(BellCymbal)
    }, 
    {
        id: 'da8355d753cd2a5ddd19cb2bb41c1547',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(RollCymbal)
    },
    {
        id: '2d01f60d0f20ab39facbf707899c6b2a',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(HihatCymbal)
    },
    {
        id: '16144544de90e98a92a265d4fc3241ea',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(HighConga)
    },
    {
        id: '0b6f94487cd8a1cf0bb77e15966656c3',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(LowConga)
    },
    {
        id: '1d4abbe3c9bfe198a88badb10762de75',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(MutedConga)
    },
    {
        id: 'fd9a67157f57f9cc6fe3cdce38a6d4a8',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(TapConga)
    },
    {
        id: '35b42d98c43404a5b1b52fb232a62bd7',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(HiNaTabla)
    },
    {
        id: 'da734693dfa6a9a7eccdc7f9a0ca9840',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(HiTunTabla)
    },
    {
        id: '9205359ab69d042ed3da8a160a651690',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(LoGehTabla)
    },
    {
        id: 'd7cd24689737569c93e7ea7344ba6b0e',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(LoGlissTabla)
    },
    {
        id: 'af5b039e1b05e0ccb12944f648a8884e',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(DuckS)
    },
    {
        id: '78b0be9c9c2f664158b886bc7e794095',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(Bubbles)
    },
    {
        id: 'c904610d770398b98872a708a2f75611',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(OceanWave)
    },
    {
        id: 'aa488de9e2c871e9d4faecd246ed737a',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(WaterDrop)
    },
    {
        id: '5e36d74bb16aa5085b901362788b0fbf',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(WolfHowl)
    },
    {
        id: 'ff8b8c3bf841a11fd5fe3afaa92be1b5',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(SpaceRipple)
    },
    {
        id: '058a34b5fb8b57178b5322d994b6b8c8',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(HorseGallop)
    },
    {
        id: '170e05c29d50918ae0b482c2955768c0',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(Cheer)
    },
    {
        id: 'b92de59d992a655c1b542223a784cda6',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(FairyDust)
    },
    {
        id: '45ffcf97ee2edca0199ff5aa71a5b72e',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(HorseS1)
    },
    {
        id: '058a34b5fb8b57178b5322d994b6b8c8',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(HorseS2)
    },
    {
        id: '0edb8fb88af19e6e17d0f8cf64c1d136',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(DanceCelebrate)
    },
    {
        id: '25f4826cdd61e0a1c623ec2324c16ca0',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(CheeChee)
    },
    {
        id: '1da43f6d52d0615da8a250e28100a80d',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(ComputerBeeps1)
    },
    {
        id: 'd4f76ded6bccd765958d15b63804de55',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(BuzzWhir)
    },
    {
        id: '46571f8ec0f2cc91666c80e312579082',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(Laser1)
    },
    {
        id: '27654ed2e3224f0a3f77c244e4fae9aa',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(Laser2)
    },

    //  Costumes  //

    //Codemino
    {
        id: 'bcf454acf82e4504149f7ffe07081dbc',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(codemino)
    },

    {
        id: 'a1ab94c8172c3b97ed9a2bf7c32172cd',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Mino2)
    },

    {
        id: '6667936a2793aade66c765c329379ad0',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Mino3)
    },

    //Finder
    {
        id: 'finder-square1',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Finder)
    },

    //Box
    /*
    {
        id: 'bimafdy83stli9srf69r5bn4osil6ocr',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Box1)
    }, {
        id: 'kro9ftjwbshdwaujf208g8cngpvrdnbs',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Box2)
    }, {
        id: 'mbjtwxlkkyyl9o4b7236xhbnc0g2z5uu',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Box3)
    }, {
        id: 'prmfoqlf9ew9exrt4iuvvh5qp0vq6i1e',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Box4)
    }, {
        id: 'rtn8qriyeymp0nga029meto5stg3znw7',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Box5)
    }, {
        id: 't9c45v1q96mfd81y9p56n6qdlc5c3o26',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Box6)
    },
	*/

	//Gold
    {
        id: '2838de5d131785c985eb0eab25ec63af',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Gold)
    },

    //TenisBall
    {
        id: '80c8f32282b697097933837905a6f257',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(TenisBall)
    }, 

    //TenisBall
    {
        id: '80c8f32282b697097933837905a6f257',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(TenisBall)
    }, 

    // Flag
    {
        id: '0cb908dbc38635cc595e6060afc1b682',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Flag)
    },

    // Pontoon
    {
        id: '17ef8f63a2a8f47258bd62cf642fd8d6',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Pontoon)
    },

    // Diamond
    {
        id: '935c7cf21c35523c0a232013a6399a49',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Pontoon)
    },

    // Award1
    {
        id: 'ecf86afea23fd95e27d4e63659adbfa6',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Award1)
    },

    // Star2
    {
        id: '40ffad793f4042a5fe7b3aaa6bc175ae',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Star2)
    },

    // Ground
    {
        id: '40ffad793f4042a5fe7b3aaa6bc175ae',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Ground1)
    },
    {
        id: '40ffad793f4042a5fe7b3aaa6bc175ae',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Ground2)
    },

    // Award
    {
        id: '643896fcad0a1bf6eb9f3f590094687c',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Award)
    },

    // Crate
    {
        id: 'c2f77473dd16d1a3713218b05390a688',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Crate)
    },

	//Astronot
    {
        id: '7d7d6f257a6bf3668a0befa4199f16a0',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Astronot1)
    },
    {
        id: 'd5b58ddd6f6b4fdcfdfd86d102853935',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Astronot2)
    },

    //Looding
    {
        id: '0fc3ac08468935694255ef8a461d4d26',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Looding1)
    },
    {
        id: 'ec4d85a60c32c7637de31dbf503266a0',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Looding2)
    },
    {
        id: '9bf9e677da34528433d3c1acb945e2df',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Looding3)
    },
    {
        id: '42e5468fa164e001925d5a49d372f4b1',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Looding4)
    },

	//Car
    {
        id: '3c46f5192d2c29f957381e0100c6085d',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Car1)
    },
    {
        id: '4b1beecd9a8892df0918242b2b5fbd4c',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Car2)
    },
    {
        id: '5e61610cbba50ba86f18830f61bbaecb',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Car3)
    },
    {
        id: '5f8301434ce176ab328f5b658ee1ec05',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Car4)
    },
    {
        id: '22817ed2e4253787c78d7b696bbefdc1',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Car5)
    },
    {
        id: '648cfdd48a7f748e6198194669ba1909',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Car6)
    },

	//Racer
    {
        id: '3c3f44aba3eff8856472e06b333a7201',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Racer1)
    },
    {
        id: '5c1d38d02ae9c4df7851a6e9d52f25b4',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Racer2)
    },
    {
        id: '47b9f910048ce4db93bdfbcd2638e19a',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Racer3)
    },
    {
        id: '001a2186db228fdd9bfbf3f15800bb63',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Racer4)
    },
    {
        id: 'fd2a94481c3ef0c223784b2f3c6df874',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Racer5)
    },
    {
        id: '5a113fcacd35ababbf23c5a9289433d1',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Racer6)
    },

    //GameButtons
    {
        id: '43a89fc1442627ca48b1dc631c517942',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(GameButtons1)
    },
   {
        id: '1a41f74cd76d7202d8b22ffc7729e03f',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(GameButtons2)
    },
    {
        id: '377eac55366670a03c469705c6689f09',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(GameButtons3)
    },
    {
        id: '9cf707e83af27c47e74adb77496ffca5',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(GameButtons4)
    },
    {
        id: '84a6dc992bce018a1eac9be0173ad917',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(GameButtons5)
    },
    {
        id: 'efc27a91c30d6a511be4245e36684192',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(GameButtons6)
    },
    {
        id: '01acd1076994a4379a3fc9e034bc05fc',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(GameButtons7)
    },
    {
        id: '4f217b14a161fcd9590614b0733100ea',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(GameButtons8)
    },
    //SpaceShip
    {
        id: 'a09376e1eacf17be3c9fbd268674b9f7',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(SpaceShip1)
    },
    {
        id: 'f6ff602902affbae2f89b389f08df432',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(SpaceShip2)
    },

    //Phantom
    {
        id: '6bd5cb8bc3e4df5e055f4c56dd630855',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Phantom1)
    },
    {
        id: '8fb61932544adbe8c95b067ad1351758',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Phantom2)
    },

    //Monstrous
    {
        id: '130cc4b9ad8dd8936d22c51c05ac6860',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Monstrous1)
    },
    {
        id: 'b28d76f648ad24932a18cb40c8d76bc5',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Monstrous2)
    },
    {
        id: 'dd713e3bf42d7a4fd8d2f12094db1c63',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Monstrous3)
    },
    {
        id: '3005df22798da45f1daf1de7421bb91d',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Monstrous4)
    },

    //Ozi
    {
        id: 'add5c5a8eec67eb010b5cbd44dea5c8d',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Ozi1)
    },
    {
        id: '4e903ac41a7e16a52efff8477f2398c7',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Ozi2)
    },
    {
        id: '83565581ecc9f7d4010efd8683a99393',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Ozi3)
    },
    {
        id: '4a3ae31dd3dd3b96239a0307cfdaa1b6',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Ozi4)
    },

	//Cyclop
    {
        id: 'd4ec9a1827429f4e2f3dc239dcc15b95',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Cyclop1)
    },
    {
        id: '85144902cc61fe98dca513b74276d7d8',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Cyclop2)
    },

	//FireFox
    {
        id: 'eec286b1cfea3f219a5b486931abedd2',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Cyclop1)
    },
    {
        id: '70520daa9f82a2347c8a8fa9e7fe1a6e',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Cyclop2)
    },
    {
        id: '99aae97a2b49904db7eeb813fa968582',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Cyclop1)
    },
    {
        id: '2c156e20da1ad4e8e397a89ad8fb1c26',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Cyclop2)
    },
    {
        id: '1bceea90292a51a7177abf581f28bf2c',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Cyclop1)
    },
    {
        id: '9cad752323aa81dfa8d8cf009057b108',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Cyclop2)
    },

    //Abby
    {
        id: '809d9b47347a6af2860e7a3a35bce057',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Abby1)
    }, {
        id: '920f14335615fff9b8c55fccb8971984',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Abby2)
    }, {
        id: '34a175600dc009a521eb46fdbbbeeb67',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Abby3)
    }, {
        id: '45de34b47a2ce22f6f5d28bb35a44ff5',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Abby4)
    },

    //Andie
    {
        id: 'b36584db82bdd45014430aa918461ca0',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Box1)
    }, {
        id: 'b3fc774e753fef520fb544127a48554b',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Box2)
    }, {
        id: 'ded71c8a0f39852178f1695b622c2d89',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Box3)
    }, {
        id: 'd92aaf6cf44921905d51ca4a10a4f3d6',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Box4)
    },

    //Apple
    {
        id: '3826a4091a33e4d26f87a2fac7cf796b',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Apple)
    },

    //Arrow
    {
        id: 'be8fcd10da0b082f8d4775088ef7bd52',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Arrow1)
    }, {
        id: '65b8e977641885010a10a46512fb95b4',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Arrow2)
    }, {
        id: 'dafcdfda65af14e172809984710f31a9',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Arrow3)
    }, {
        id: '70ffa0bae8693418459f21f370584f6d',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Arrow4)
    },

    //Avery
    {
        id: 'f52bde34d8027aab14b53f228fe5cc14',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Avery1)
    }, {
        id: '944385ea927e8f9d72b9e19620487999',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Avery2)
    },

    //AveryWalking
    {
        id: 'dc6a584704c09a3fbafb9825635a9fd4',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(AveryWalking1)
    }, {
        id: '448e54fb14b13d492885fc247e76b7f4',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(AveryWalking2)
    }, {
        id: '3a935fe75ac999e22b93d06b3081a271',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(AveryWalking3)
    }, {
        id: '8f439476a738251043d488d7a4bc6870',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(AveryWalking4)
    },

    //Ball
    {
        id: '3c6241985b581284ec191f9d1deffde8',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Ball1)
    }, {
        id: 'ad7dc51cafd73e8279073e33b0eab335',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Ball2)
    }, {
        id: 'f221a2edf87aff3615c0c003e616b31b',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Ball3)
    }, {
        id: 'db144b2a19f4f1ab31e30d58f00447dc',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Ball4)
    }, {
        id: '1c44b7494dec047371f74c705f1d99fc',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Ball5)
    },


    //Ballerina
    {
        id: '5197d3778baf55da6b81b3ada1e10021',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Ballerina1)
    }, {
        id: '4ccb1752a43f48aafe490c9c08e58c27',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Ballerina2)
    }, {
        id: 'fc02bf591dd3d91eeeb50c7424d08274',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Ballerina3)
    }, {
        id: '5aae21aee33c3f1ae943af5ea11254bf',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Ballerina4)
    },

    //Balloon
    {
        id: 'd7974f9e15000c16222f94ee32d8227a',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Balloon1)
    }, {
        id: 'a2516ac2b8d7a348194908e630387ea9',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Balloon2)
    }, {
        id: '63e5aea255610f9fdf0735e1e9a55a5c',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Balloon3)
    }, 

    //Bananas
    {
        id: 'e5d3d3eb61797f5999732a8f5efead24',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Bananas)
    }, 

    //Baseball
    {
        id: '74e08fc57820f925c7689e7b754c5848',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Baseball)
    }, 

    //Basketball
    {
        id: '6b0b2aaa12d655e96b5b34e92d9fbd4f',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Basketball)
    }, 

    //Bat
    {
        id: '4e4ced87ed37ee66c758bba077e0eae6',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Bat1)
    }, {
        id: 'bc6dd12fc9e407c7774959cdf427f8b5',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Bat2)
    }, {
        id: '60f5bfce5d9b11bfcd199a6aa5454b3f',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Bat3)
    }, {
        id: '698c2a48e774f9959d57c9618b156c20',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Bat4)
    },

    //Batter
    {
        id: '9d193bef6e3d6d8eba6d1470b8bf9351',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Batter1)
    }, {
        id: 'fdfde4bcbaca0f68e83fdf3f4ef0c660',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Batter2)
    }, {
        id: 'bd4fc003528acfa847e45ff82f346eee',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Batter3)
    }, {
        id: '592ee9ab2aeefe65cb4fb95fcd046f33',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Batter4)
    },

    //Beachball
    {
        id: '5198b5a03ebae60698e0906f59a5fc15',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Beachball)
    },

    //Bear
    {
        id: 'deef1eaa96d550ae6fc11524a1935024',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Bear1)
    }, {
        id: '6f303e972f33fcb7ef36d0d8012d0975',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Bear2)
    },

    //BearWalking
    {
        id: '6d4d06e3f4cd0c9455b777b9a40782b6',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(BearWalking1)
    }, {
        id: '7453709bef16e33e6f989aee14d7fc07',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(BearWalking2)
    }, {
        id: '6d50c5fe63ab5f77d10144a68ca535a6',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(BearWalking3)
    }, {
        id: 'e531b307381c2aa148be4ccc36db0333',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(BearWalking4)
    }, {
        id: '0a38a860f2e573b8dc5b09f390d30fbd',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(BearWalking5)
    }, {
        id: 'f36c80d2e731be95df7ec6d07f89fa00',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(BearWalking6)
    }, {
        id: 'd2a5f124f988def1d214e6d0813a48f3',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(BearWalking7)
    }, {
        id: '36d06aa23c684fc996952adb0e76e6b4',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(BearWalking8)
    },

    //Beetle
    {
        id: '46d0dfd4ae7e9bfe3a6a2e35a4905eae',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Beetle)
    },

    //Bell
    {
        id: '8c0234fe1bfd36f5a72e975fbbc18bfd',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Bell)
    },

    //Ben
    {
        id: '2cd77b8a9961e7ad4da905e7731b7c1b',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Ben1)
    }, {
        id: '165d993c30dfdb9e829d0d98867d7826',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Ben2)
    }, {
        id: '9f9f88aea3457084d8d734040b0b9067',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Ben3)
    }, {
        id: 'acc208e29f0422c2bcffa3b8873abc63',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Ben4)
    },

    //Bowl
    {
        id: 'd147f16e3e2583719c073ac5b55fe3ca',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Bowl)
    },

    //Bowtie
    {
        id: '4b032ba44b8077439e73815542e7ed23',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Bowtie)
    },

    //Bread
    {
        id: '585de1550446d4420f8a10fdecac995b',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Bread)
    },

    //Broom
    {
        id: '556288a1c996345c751a3dc88b570cfa',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Broom)
    },

    //Buildings
    {
        id: 'e8c9508b1f6a0a432e09c10ef9ada67c',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Buildings1)
    }, {
        id: 'a8c977a3b85ffe8c8b453c9d668989b8',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Buildings2)
    }, {
        id: 'e4764cfc384a499f92da3ea745bcebe2',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Buildings3)
    }, {
        id: 'd1fcce0aac589a17324943a3b759fc2a',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Buildings4)
    },  {
        id: 'bb47a3d5d03a34937557c558c6cb5d18',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Buildings5)
    }, {
        id: '80b120b7152ed72fded84fef485f4f79',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Buildings6)
    }, {
        id: '4212ff1769c169bfa0db043b18fdade8',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Buildings7)
    }, {
        id: '8f64966be60d332b345598819c67a8b6',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Buildings8)
    }, {
        id: 'fcedb6b25a2db6de28b39130f978b0bf',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Buildings9)
    }, {
        id: '148034b1557cc3dae39953e43ab50ff0',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Buildings10)
    },

    //Butterfly1
    {
        id: 'fe98df7367e314d9640bfaa54fc239be',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Butterfly1a)
    }, {
        id: '49c9f952007d870a046cff93b6e5e098',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Butterfly1b)
    }, {
        id: '34b76c1835c6a7fc2c47956e49bb0f52',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Butterfly1c)
    },

    //Butterfly2
    {
        id: '372ae0abd2e8e50a20bc12cb160d8746',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Butterfly2a)
    }, {
        id: 'e96f4c6913107c9b790d37bb65507c14',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Butterfly2b)
    },

    //Button1

    {
        id: '21fb7fa07eac4794fded0be4e18e20a2',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Button1)
    }, 

    //Button2
    {
        id: 'af4cd54e776031bc9cc54ddd6892f97b',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Button2a)
    }, {
        id: 'e96f4c6913107c9b790d37bb65507c14',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Button2b)
    },

    //Button3
    {
        id: '5021f6b7d166873ef0711c4d4a351912',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Button3a)
    }, {
        id: 'a3b357ea21773bcb3545a227ee877e9a',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Button3b)
    },

    //Button4
    {
        id: '71ced7c192168c7b221d16b4eaff440e',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Button4a)
    }, {
        id: '7d34ad26633abbc752c9cd93ace0a81f',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Button4b)
    },

    //Button5
    {
        id: '94957f2f79e8970d8b2cd0f74a0c1ffc',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Button4a)
    }, {
        id: 'a4bb9a9e06e65337798471035719985a',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Button4b)
    },

    //Cake
    {
        id: '862488bf66b67c5330cae9235b853b6e',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Cake1)
    }, {
        id: 'dfe9c5d40da0dcc386fad524c36d3579',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Cake2)
    },

    //Casey
    {
        id: 'e5a47371f3e9f853b36560cda35344b6',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Casey1)
    }, {
        id: 'e09e5ef2bdeb69163a543f3216c1f54c',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Casey2)
    }, {
        id: '50bd5162671b8a30fcfa3082a9e79ec4',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Casey3)
    }, {
        id: 'ebc3de539e02801d420268eb189c5a47',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Casey4)
    },

    //Catcher
    {
        id: '895cdda4f2bd9d6f50ff07188e7ce395',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Catcher1)
    }, {
        id: 'a31e30677637ae4de975d40b6d822853',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Catcher2)
    }, {
        id: '99af13802e9bfd7b4a4bfb8ead825c0c',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Catcher3)
    }, {
        id: '8aa875f077c405e2045f5ab60705e712',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Catcher4)
    },

    //Centaur
    {
        id: 'd722329bd9373ad80625e5be6d52f3ed',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Centaur1)
    }, {
        id: '2373556e776cad3ba4d6ee04fc34550b',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Centaur2)
    }, {
        id: 'd7aa990538915b7ef1f496d7e8486ade',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Centaur3)
    }, {
        id: 'c00ffa6c5dd0baf9f456b897ff974377',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Centaur4)
    },

    //Character1
    {
        id: '03bc23a9fa12c1244c83a07a81f20bfd',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Character1a)
    }, {
        id: 'f26b130c2c58b812be21d1a9745863a1',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Character1b)
    }, {
        id: 'cc0be722cf93eef63726bd606ab11c5c',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Character1c)
    }, {
        id: '6be261800647c53becb1f93ed31ed13e',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Character1d)
    }, {
        id: '6f78ce6a87d114162ed9fbef30f9a0fd',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Character1e)
    }, {
        id: '527ba82c5e82f43c8fca0be905dbe20a',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Character1f)
    }, {
        id: '1e303bb57aac0cb4678e85de4251f3f4',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Character1g)
    }, {
        id: '0f18f9e90d0ed68ebec23da087eb2603',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Character1h)
    }, {
        id: '5e2f620e5687a36e1954414054c69ccc',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Character1i)
    }, {
        id: '1044a68cc743f83564e36a6bca16830b',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Character1j)
    }, {
        id: 'b37d0e0d46f07cb2cbdc5285e176bf62',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Character1k)
    }, {
        id: '984043e1e7c544999c31f952d1d43a56',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Character1l)
    }, {
        id: '6d5ddfc69f9c6a3f1d2ded1428237931',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Character1m)
    },

    //Character2
    {
        id: '7084b3baab935de819cc5ab46f7cecf8',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Character2a)
    }, {
        id: 'df7cbf2913bcea721df2e0360644f193',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Character2b)
    }, {
        id: 'e0eacf1e575adc559c41e3a81a892168',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Character2c)
    }, {
        id: 'e8b44b0e904fd4bb7430c26b743f1520',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Character2d)
    }, {
        id: '67d425b11544caa0fe9228f355c6485b',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Character2e)
    }, {
        id: 'db3f436fcb6fb28828a4c932b60feb5e',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Character2f)
    }, {
        id: '93e035270675f933b94ee951d7e475e3',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Character2g)
    }, {
        id: 'f4f2778df2840de5a6449a49f3efb599',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Character2h)
    }, {
        id: '1cf73a791959e07b5bafe18474f93b78',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Character2i)
    }, {
        id: 'bf0d808f7bf0c11c338b4fea0a735874',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Character2j)
    }, 

    //Chick
    {
        id: '80abbc427366bca477ccf1ef0faf240a',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Chick1)
    }, {
        id: '5e23c8c28ffd390df7deb2414be37781',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Chick2)
    }, {
        id: '77911bbe5e11ede35871e8002a26356d',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Chick3)
    }, 

    //CityBus
    {
        id: 'e9694adbff9422363e2ea03166015393',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(CityBus1)
    }, {
        id: '7d7e26014a346b894db8ab1819f2167f',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(CityBus2)
    },

    //Cloud

    {
        id: 'c9630e30e59e4565e785a26f58568904',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Cloud1)
    }, {
        id: '9f5958f46d21e33d3f6d7caffbe0daa9',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Cloud2)
    }, {
        id: '9105d7dd90b5f2a4b85a1e71aff8703f',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Cloud3)
    }, {
        id: '0188b2c7c85176b462881c6bca7a7748',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Cloud4)
    }, {
        id: '9f2eccce13e3e5fd212efd59ff1d96a0',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Cloud5)
    },

    //Convertible3
    {
        id: '621817ef84ad81f5690fac95adab2ede',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Convertible3)
    },

    //Crab
    {
        id: 'f7cdd2acbc6d7559d33be8675059c79e',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Crab1)
    }, {
        id: '49839aa1b0feed02a3c759db5f8dee71',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Crab2)
    },

    //Crystal
    {
        id: 'ecd1e7805b37db4caf207b7eef2b7a42',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Crystal1)
    }, {
        id: '0a7b872042cecaf30cc154c0144f002b',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Crystal2)
    },

    //Dani
    {
        id: '6518333c95cf96a9aaf73a4a948e002f',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dani1)
    }, {
        id: '2cba86439098a7e0daa46e0ff8a59f7c',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dani2)
    }, {
        id: 'b5f989e21b56af371209369c331b821e',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dani3)
    },

    //Dee
    {
        id: '43bd4c241a94b3aea883472d7dab5afc',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dee1)
    }, {
        id: 'e4c6ada3509f7033d14bac2c0eea49dc',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dee2)
    }, {
        id: '1de3bbee2771b0ff16c4658d5ad98b0b',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dee3)
    }, {
        id: '320a892c86e9b039ba9d6d50a4897276',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dee4)
    }, {
        id: 'c57c4593701165cdea6de9b014c7c06d',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dee5)
    },

    //Devin
    {
        id: '5f614017dba0ce6bff063f6c62041035',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Devin1)
    }, {
        id: '9d7414a719d6cc5e0e9071ede200a29c',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Devin2)
    }, {
        id: '5ab51aeaa296e955e75a7a3c103ebb99',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Devin3)
    }, {
        id: 'bfc7c20b64f86d4b207780f3da695fa4',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Devin4)
    },

    //Dinosaur1
    {
        id: '45b02fbd582c15a50e1953830b59b377',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dinosaur1a)
    }, {
        id: '7f89417968116ada83d4ddaad22403b3',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dinosaur1b)
    }, {
        id: '22d94ee5daf557284465425a61186234',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dinosaur1c)
    }, {
        id: 'af158d368bf3da576369be1130e18acd',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dinosaur1c)
    },

    //Dinosaur2
    {
        id: '7799f2848136d11f48ca5f3105d336ef',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dinosaur2a)
    }, {
        id: 'd926c5758d130fcfd9a7ae7dac47e47d',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dinosaur2b)
    }, {
        id: '0e43f8e573bf232505b207b92efac2ac',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dinosaur2c)
    }, {
        id: 'e606ba27dfe94daf3d8e3fdf599e37cf',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dinosaur2c)
    },

    //Dinosaur3
    {
        id: 'd85ec1b97f73564ef26fec73d5056c68',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dinosaur3a)
    }, {
        id: 'e731d1f1ebf4bc0ea55b850ffe5a5f96',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dinosaur3b)
    }, {
        id: 'ae98efa1c3c3700602e1344db86aaf72',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dinosaur3c)
    }, {
        id: 'cf4fb77a4e9839f83d3fa5fc0982ccd3',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dinosaur3d)
    }, {
        id: '5381feb0fc1b50ddc2793342daddffef',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dinosaur3e)
    },

    //Dinosaur4
    {
        id: 'a98e3f93853513e7c00bab4c61752312',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dinosaur4a)
    }, {
        id: 'ac99ef62e3e018b8db550bb2a187cbe9',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dinosaur4b)
    }, {
        id: 'c63cca929380152b978d8671fe6003f7',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dinosaur4c)
    }, {
        id: '723bd1559f8baae4184fa24a6513362b',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dinosaur4d)
    }, 

    //Diver1
    {
        id: 'a24f23a0f5d77cfb59721ef8f6bfe5c7',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Diver1)
    },

    //Diver2
    {
        id: 'ef8136a42b7d20961756e551bc87b37f',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Diver2)
    },

    //Dog1
    {
        id: '35cd78a8a71546a16c530d0b2d7d5a7f',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dog1a)
    }, {
        id: 'd5a72e1eb23a91df4b53c0b16493d1e6',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dog1b)
    },

    //Dog2
    {
        id: '66b435d333f34d02d5ae49a598bcc5b3',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dog2a)
    }, {
        id: '6afc06388d69f99e28d883126f9b2734',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dog2b)
    }, {
        id: '4708bff29b3a295a03ac1d5e2d16ec75',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dog2c)
    },

    //Donut
    {
        id: '316a67c9e966fd015b4538f54be456db',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Donut)
    },

    //Dorian
    {
        id: 'a9a064a1f28c9e22b594dcea1d46025b',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dorian1)
    }, {
        id: '7d20ec98603857c031c1f4ad2bd8ea51',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dorian2)
    }, {
        id: '8f2be2387efcbb5d4878886adaa2a88e',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dorian3)
    }, {
        id: '603d3dd151984c0eaa2822f70a234c28',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dorian4)
    },

    //Dot
    {
        id: '106461f60e34ce231b323e2dd2d9f05b',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dot1)
    }, {
        id: '21482022f9930400302bc8ec70643717',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dot2)
    }, {
        id: '9e5a6cc6970ce4932a09affba70a45b0',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dot3)
    }, {
        id: 'fb047c94113ee4c6664305a338525e6a',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dot4)
    },

    //Dove
    {
        id: '0f83ab55012a7affd94e38250d55a0a0',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dove1)
    }, {
        id: '778a699a044a0a8c10f44c3194e21ef2',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dove2)
    },

    //Dragon
    {
        id: '12ead885460d96a19132e5970839d36d',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dragon1)
    }, {
        id: '3f672475ad4ca5d1f9331cffd4223140',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dragon2)
    }, {
        id: 'e0aa0083fa0b97da97600d4dbb2055e5',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dragon3)
    },

    //Dragonfly
    {
        id: '5cdfe67af929e3fb095e83c9c4b0bd78',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dragonfly1)
    }, {
        id: '17b864c1ddd4b349a6c4bd5709167307',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dragonfly2)
    }, 
     
    //Dress
    {
        id: 'ddbea537af6012ebac18d16d65c07479',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dress1)
    }, {
        id: '4e22e6fd72500f0a25b959283bfd0a32',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dress2)
    }, {
        id: 'c5fb135d89573570010b0d96c94bcec6',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Dress3)
    },

    //Drum
    {
        id: 'ce6971317035091341ec40571c9056e9',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Drum1)
    }, {
        id: '47531b5675be696d0540eb120d5d0678',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Drum2)
    },

    //Drum Kit
    {
        id: 'baf6344b6f55b074786a383c1097697d',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(DrumKit1)
    }, {
        id: '3f4fb4836338c55f883607c403b2b25e',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(DrumKit2)
    },

    //DrumCymbal
    {
        id: '78398692e6fa226568df0374c4358da4',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(DrumCymbal1)
    }, {
        id: '08355ec8cc4b3263f502adfdea993cda',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(DrumCymbal2)
    },

    //Drum-highhat
    {
        id: '15b2a31a57d0cd911ad0b1c265dcf59e',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(DrumHighhat1)
    }, {
        id: '866b3a49ee2a45998940e2d737c4c502',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(DrumHighhat2)
    },

    //Drum-snare
    {
        id: 'c42bb05aab3cacddcd88712e33ab8df0',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(DrumSnare1)
    }, {
        id: '28298d93f5282041267a92bd67308107',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(DrumSnare2)
    },

    //Drums Conga
    {
        id: '2b2eacfce0fb1af023e6ca0f5ef6defe',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(DrumsConga1)
    }, {
        id: 'bdad2f140cfbd021f38241fc9acc7fd2',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(DrumsConga1)
    },

    //Drums Tabla
    {
        id: 'af071d9d714c5c622e2bb07133698ce3',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(DrumsTabla1)
    }, {
        id: '992d6359be830d977559dad91b04f698',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(DrumsTabla2)
    },

    //Duck
    {
        id: 'c9837d0454f5f0f73df290af2045359b',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Duck)
    },

    //Earth
    {
        id: '7405b5efa96995bae6853667f8cd145e',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Earth)
    },

    //Easel
    {
        id: 'a4b3714322c11b350f09a75921ae606b',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Easel1)
    }, {
        id: '6a736beddc7844538be390c18b7c4361',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Easel2)
    }, {
        id: 'caec09682a7fcdffef4647e8355ba004',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Easel3)
    },

    //Egg
    {
        id: 'f8ee449298c1446cb0ef281923a4e57a',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Egg1)
    }, {
        id: 'fbc629c3b062423e8c09cfacfb1e65f8',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Egg2)
    }, {
        id: '0d127490af16f8a4ca5ce3212b2391c2',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Egg3)
    }, {
        id: 'b0b6e88ec64b842398200bab562b53e3',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Egg4)
    }, {
        id: '41535b4742f40e2630746b0c4bec98f2',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Egg5)
    }, {
        id: 'bb0505b802140a8cc200c9f8bfce4503',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Egg6)
    },

    //Elephant
	{
        id: 'b59873e9558c1c456200f50e5ab34770',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Elephant1)
    }, {
        id: '2c9b5e0125d95b8bc511f6bb09b5ea2f',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Elephant2)
    },

    //Elf
   	{
        id: 'e92abad171396a3198455df8557802e5',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Elf1)
    }, {
        id: '92ff640b911a8348d2734c0e38bba68c',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Elf2)
    },   	{
        id: '524406c2b1fe253c1565ff516309817e',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Elf3)
    }, {
        id: '808c6fa2eb1cba0de1d17b18c6f41279',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Elf4)
    },   	{
        id: 'ec458328a85f89f06866e2337076ac0a',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Elf5)
    }, 

    //Fairy
    {
        id: '40d726e17bfd2ffeb8c0aa5393ee1c77',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Fairy1)
    }, {
        id: 'bea920473027f43e04c44e588c6cc39a',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Fairy2)
    },   	{
        id: 'd4f6163a1610243f55dd9cf1c9875c61',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Fairy3)
    }, {
        id: '902350bba0d4b4612db1e2e902b6f201',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Fairy4)
    },   	{
        id: 'decd31f829032b1d4dcf5efdbd362cb9',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Fairy5)
    }, 

    //Fish
    {
        id: 'a9b3d163756621f8395592ad77fb9369',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Fish1)
    }, {
        id: '7a0c31c0087f342867d4754f8dc57541',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Fish2)
    }, {
        id: '4a3478b3cdc3e8688a671be88c2775fd',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Fish3)
    }, {
        id: '886e0bb732453eb8d3a849b4eab54943',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Fish4)
    },

    //Fishbowl
    {
        id: '17c53cf0296f24722ba5b001d513e58f',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Fishbowl1)
    }, {
        id: 'b3db01c5cda32fe3ea0b48dde5fa8130',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Fishbowl2)
    }, 

    //Food Truck
    {
        id: 'a77f9693f87288d023a4632cf019776e',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(FoodTruck1)
    }, {
        id: 'f4150de2297a63c3efd125c8e12dd7cc',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(FoodTruck2)
    }, {
        id: 'e850e3c93de767519f7f78b38f16ed1d',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(FoodTruck3)
    }, 

    //Fox
    {
        id: '9dd59a4514b5373d4f665db78e145636',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Fox1)
    }, {
        id: '2c256eacbb753be361e8e52a0eefde77',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Fox2)
    },  {
        id: 'dd398ed81edb60c91ad4805f4437d2fa',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Fox3)
    }, 

    //Frank
    {
        id: '10d39bb7e31647a465e747cd243b8cd0',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Frank1)
    }, {
        id: 'e56e930cc0229d1042a673e7503209c5',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Frank2)
    }, {
        id: '26da9617218493f4f42a1592f21afee8',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Frank3)
    }, {
        id: 'd16b76a634f7367ce7d6112401a78e57',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Frank4)
    }, 

    //Frog
    {
        id: '390845c11df0924f3b627bafeb3f814e',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Frog)
    },
     
    //Frog 2
    {
        id: 'f2246c13e4540472c484119bc314d954',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Frog1)
    }, {
        id: 'd9f69469090784d8dd68d94c0fd78a50',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Frog2)
    }, {
        id: '0717f446c991aac7df2fe4d6590354e7',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Frog3)
    },

    //Fruit Salad
    {
        id: '2e6ef315101433b78e38719e8cc630c2',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(FruitSalad)
    },

    //Ghost
    {
        id: 'f522b08c5757569ad289d67bce290cd0',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Ghost1)
    }, {
        id: 'd1d89391f1d9c74557e504456d58a002',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Ghost2)
    }, {
        id: '634744e3f98bee53e9cb477a63aa9b21',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Ghost3)
    }, {
        id: '40ba3a0b5b3899a655fd8867229d4ee3',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Ghost4)
    },

    //Gift
    {
        id: '0fdd104de718c5fc4a65da429468bdbd',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Gift1)
    }, {
        id: '6cbeda5d391c6d107f0b853222f344d9',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Gift2)
    },

    //Giga
    {
        id: '92161a11e851ecda94cbbb985018fed6',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Giga1)
    }, {
        id: 'bc706a7648342aaacac9050378b40c43',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Giga2)
    }, {
        id: '337b338b2b10176221e638ac537854e6',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Giga3)
    }, {
        id: 'db15886cfdcb5e2f4459e9074e3990a1',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Giga4)
    },

    //Giga Walking
    {
        id: '3afad833094d8dff1c4ff79edcaa13d0',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(GigaWalking1)
    }, {
        id: 'd27716e022fb5f747d7b09fe6eeeca06',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(GigaWalking2)
    }, {
        id: 'db55131bf54f96e8986d9b30730e42ce',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(GigaWalking3)
    }, 

    //Giraffe
    {
        id: '43e89629fb9df7051eaf307c695424fc',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Giraffe1)
    }, {
        id: 'ef1fca2ae13d49d9dd2c6cfc211a687c',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Giraffe2)
    }, {
        id: 'cfd93a103479993aee4d680655e39d8d',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Giraffe3)
    }, 

    //Glass Water
    {
        id: 'cbf21cf1b057852f91135d27ebbf11ce',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(GlassWater1)
    }, {
        id: 'ca70c69ef1f797d353581a3f76116ae3',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(GlassWater2)
    },

    //Glasses
    {
        id: '705035328ac53d5ce1aa5a1ed1c2d172',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Glasses1)
    }, {
        id: 'f2a02d0e7431147b8a4a282e02a8e6a4',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Glasses2)
    }, {
        id: '9e2f75d3a09f3f10d554ba8380c3ae52',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Glasses3)
    }, {
        id: 'acd85b36e6b8d93ba4194ee2ea334207',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Glasses4)
    },

    //Goalie
    {
        id: 'a554f2a9b49a09ec67d1fd7ecfbcddcd',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Goalie1)
    }, {
        id: '59eedd0a23c3c983d386a0c125991c7f',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Goalie2)
    }, {
        id: 'f2e7ba53f3a28c4359cb0d3e3cb4001a',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Goalie3)
    }, {
        id: '63f2955298d59dd22dc7b7c6a9c521e2',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Goalie4)
    }, {
        id: 'eb096e2b4234f5f8ee1f2c44429eaa1a',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Goalie5)
    },

    //Goblin
    {
        id: '3f08380f25062b8055a1800f5dad14bd',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Goblin1)
    }, {
        id: 'b8604b8039d6b633015aaf17d74d5d5b',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Goblin2)
    }, {
        id: '2add9ef4eaa25f8915406dcfd8bafc9f',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Goblin3)
    }, {
        id: 'afb9fe328adae617ee3375366fca02e7',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Goblin4)
    },

    //Grasshopper
    {
        id: 'e7210a370837dd1e4ebc1a56a973b7f6',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Grasshopper1)
    }, {
        id: '529644c5ecdca63adafd87777e341ad7',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Grasshopper2)
    }, {
        id: 'cf2ac769df444137b4c1eec472fa4b92',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Grasshopper3)
    },    {
        id: 'a7c638b8aa86f2a758830f8c2b0e4cf5',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Grasshopper4)
    }, {
        id: 'd4f3dfe69be6537e73544381408a820d',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Grasshopper5)
    }, {
        id: '93550d8abde130ad149904c4448f8b65',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Grasshopper6)
    },

    //Green Flag
    {
        id: '2bbfd072183a67db5eddb923fe0726b3',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(GreenFlag)
    },

    //Griffin
    {
        id: 'a31166d45903206b52cb0f0a0cb687b5',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Griffin1)
    }, {
        id: '102f6200c13bd60afa9538c712776fb0',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Griffin2)
    }, {
        id: '157d3665cebcd41fa814b9217af99476',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Griffin3)
    },    {
        id: 'b8c8745820a341afec08e77f4a254551',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Griffin4)
    }, 

    //Hare
    {
        id: '7269593d83b6f9eae512997f541a7417',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Hare1)
    }, {
        id: 'c8dbb4302dd489a201938c203018c2f0',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Hare2)
    }, {
        id: '85a3b8c151e10576fa531a4293fdac00',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Hare3)
    }, 

    //Harper
    {
        id: '3a0973a042ee16e816c568651316d5d4',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Harper1)
    }, {
        id: 'e407fa0ed992393d12d0a108c11e2fa6',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Harper2)
    }, {
        id: '98ce6e6bb99f8ba116f127fdf2e739fd',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Harper3)
    }, 

    // Hat
    {
        id: 'c632719725400c604fcadf0858ce2b2c',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Hat1)
    }, {
        id: '0aed53a86d92ec2283068000ac97a60b',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Hat2)
    }, {
        id: '13e382ae3f05a9a23e0b64ca23230438',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Hat3)
    }, {
        id: '6349e36da9897a2f89bdbf5c77dbdacb',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Hat4)
    }, 

    //Hatchling
    {
        id: '55f7d457eb0af78cb309ca47497c490f',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Hatchling1)
    }, {
        id: '0e5c295a043d5e183a98046e4f734b72',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Hatchling2)
    }, {
        id: 'f27d557be70a9522fae4392bfd4f5249',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Hatchling3)
    },  

    //Heart
    {
        id: 'c77e640f6e023e7ce1e376da0f26e1eb',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Heart1)
    }, {
        id: 'e24731f5cf2759c2f289921bebb86ea2',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Heart2)
    },

    //Heart Candy
    {
        id: '288976865e8c5db717d859e915606d82',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(HeartCandy1)
    }, {
        id: '51248e76be2aa7a0f0ed77bc94af1b3a',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(HeartCandy2)
    }, {
        id: '3ee430ba825f41ae9913453d4932fb8b',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(HeartCandy3)
    }, {
        id: '5fa8c4693cf8cba8cdbcbed72f4f58aa',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(HeartCandy4)
    },

    //Heart Face
    {
        id: '989770846f8cd1628b48bbe91d0a7d0d',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(HeartFace)
    }, 

    //Hedgehog
    {
        id: '3b0e1717859808cecf1a45e2a32dc201',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Hedgehog1)
    }, {
        id: '42bac40ca828133600e0a9f7ba019adb',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Hedgehog2)
    }, {
        id: '3251533232e7f44315512149c7f76214',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Hedgehog3)
    }, {
        id: '93c2d7a0abefaf26ee50d5038ac5bf61',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Hedgehog4)
    }, {
        id: '1fcbba4a2252e96c52d2d8aa8e593e51',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Hedgehog5)
    },

    //Hen
    {
        id: 'b02a33e32313cc9a75781a6fafd07033',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Hen1)
    }, {
        id: 'd055896a473bb12f4ec67af1fdb9c652',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Hen2)
    }, {
        id: 'c9a4570a2d0ae09b9feeeb5607e4b9c7',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Hen3)
    }, {
        id: '6c9e05f568862dbcea0a1652a210239b',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Hen4)
    }, 

    //Hippo
    {
        id: '911901dc568b56c15fe81819bc2af653',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Hippo1)
    }, {
        id: '5764a2c650f225bc27cc0e6c5db401ea',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Hippo2)
    }, 

    //Home Button
    {
        id: '1ebdcb9f033fa6658259b52da376b7ac',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(HomeButton)
    }, 

    //Horse
    {
        id: 'ad458251c5bf5b375870829f1762fa47',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Horse1)
    }, {
        id: '0e0fa871bea01c2dfb70e9955dc098be',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Horse2)
    }, 

    //Jamal
    {
        id: '3c8d5e688450ad1e6bf024a32c55bcda',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Jamal1)
    }, {
        id: '2408318e743873c7254db1623441b9c5',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Jamal2)
    }, {
        id: '693748d763c8da4b119a5e4bee6a1768',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Jamal3)
    }, {
        id: '92692e0c0f376797274392484ba74133',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Jamal4)
    },

    //Jar
    {
        id: '33b537168f3c2eb3dafeb739c22f38a6',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Jar1)
    }, {
        id: 'e0f5ac773987470ff2467e3e01b9ab23',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Jar2)
    },

    //Jellyfish
    {
        id: '4e259b7c08f05145fc7800b33e4f356e',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Jellyfish1)
    }, {
        id: '5944a1e687fa31589517825b2144a17b',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Jellyfish2)
    }, {
        id: '00c99df84f8385038461d6c42a5465ab',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Jellyfish3)
    }, {
        id: '3158299771b3d34ed2c50a00fbab715e',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Jellyfish4)
    },

    //Jordyn
    {
        id: 'db4d97cbf24e2b8af665bfbf06f67fa0',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Jordyn1)
    }, {
        id: 'a7cc1e5f02b58ecc8095cfc18eef0289',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Jordyn2)
    }, {
        id: '768c4601174f0dfcb96b3080ccc3a192',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Jordyn3)
    }, {
        id: '00c8c464c19460df693f8d5ae69afdab',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Jordyn4)
    },

    //Key
 	{
        id: '680d3e4dce002f922b32447fcf29743d',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Key)
    },

    //Keyboard
    {
        id: '0ad880b5e829578832c8927b3f6ef7f8',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Keyboard1)
    }, {
        id: '6efd23c91dab070526feacdf72e2d3da',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Keyboard2)
    },

    //Kia
    {
        id: 'e56e480c994572323d88355b8733e1a3',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Kia1)
    }, {
        id: 'b3d0a248adbc26b0d0826e042a81670a',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Kia2)
    }, {
        id: 'db6cd6b145bb6d8dc299475af7423d6e',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Kia3)
    },

    //Kiran
    {
        id: '7c0bedab5404830a5147cc4a2d46e997',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Kiran1)
    }, {
        id: 'b0566e0eed7b5216b92d61468d21ecee',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Kiran2)
    }, {
        id: '78bd6de23d4929aef678ddf0f3f5c276',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Kiran3)
    }, {
        id: '2928e9fbd5ca08e326192b3a41bea691',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Kiran4)
    }, {
        id: '7912b6f378bd781f62683e003c574dbe',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Kiran5)
    }, {
        id: '7f0bc123819fc2666321b6cd38069bdb',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Kiran6)
    },

    //Knight
    {
        id: '188325c56b79ff3cd58497c970ba87a6',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Knight)
    },

    //Ladybug1
    {
        id: '169c0efa8c094fdedddf8c19c36f0229',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Ladybug1)
    },

    //Ladybug2
    {
        id: '457200f8dec8fea00d22473e9bd9175e',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Ladybug2a)
    },    {
        id: '3f48228829b77fc47d6d89b5729b2957',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Ladybug2b)
    }, 

    //Lightning
    {
        id: '0ddd3a05a330925bcd2d048908ed40b8',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Lightning)
    },

    //Line
    {
        id: 'e85305b47cfd92d971704dcb7ad6e17b',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Line)
    },

    //Lion
    {
        id: 'e88e83c8b3ca80c54540b5f0c5a0cc03',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Lion1)
    }, {
        id: 'f0d9ab3d82bbade6e279dc1c81e2e6db',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Lion2)
    }, {
        id: '91c64c5361d906fd36d5813ae27b85a8',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Lion3)
    },

    //Monkey
    {
        id: '254926ee81bfa82f2db7009a80635061',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Monkey1)
    }, {
        id: 'de0405b0576ade1282bdfcd198922baa',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Monkey2)
    }, {
        id: 'ec6d62f0ff64bb5440ffdc662b6e46fa',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Monkey3)
    },

    //Nano
    {
        id: 'a62e560863c0e49b12e5d57e13d084f1',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Nano1)
    }, {
        id: 'd12aead3e3c2917e7eba8b2b90a7afd2',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Nano2)
    }, {
        id: '8f2f4a70e87262ef478ce60567b6208a',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Nano3)
    }, {
        id: 'a4e2034751fa650fd5fd69432c110104',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Nano4)
    },

    //Neigh Pony
    {
        id: '592816f56409d582603c485cbefcbbb8',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(NeighPony)
    },

    //Parrot
    {
        id: '082f371c206f07d20e53595a9c69cc22',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Parrot1)
    },    {
        id: '036fad20b674197358f8c0b2dc64e17e',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Parrot2)
    },

    //Penguin
    {
        id: '428772307d90f4b347d6cc3c0d8e76ef',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Penguin1)
    }, {
        id: 'd485f5620d2dde69a6aa1cda7c897d12',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Penguin2)
    }, {
        id: '280d2aa13f0c6774cc8828dc177aaf60',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Penguin3)
    },    {
        id: '780467f3d173dcb37fd65834841babc6',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Penguin4)
    },

    //Pico
    {
        id: 'e7ce31db37f7abd2901499db2e9ad83a',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Pico1)
    }, {
        id: 'a7597b1f0c13455d335a3d4fe77da528',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Pico2)
    }, {
        id: 'bcc0e8a5dda3a813608902b887c87bb4',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Pico3)
    }, {
        id: 'd6dfa2efe58939af4c85755feb3c0375',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Pico4)
    },

    //Pico Walking
    {
        id: 'c8f58f31cabf4acabb3f828730061276',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(PicoWalking1)
    }, {
        id: '52a60eccb624530fd3a24fc41fbad6e5',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(PicoWalking2)
    }, {
        id: '702bd644d01ea8eda2ea122daeea7d74',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(PicoWalking3)
    },  {
        id: '22fb16ae7cc18187a7adaf2852f07884',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(PicoWalking4)
    },

    //Retro Robot
	{
        id: '35070c1078c4eec153ea2769516c922c',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(RetroRobot1)
    }, {
        id: 'd139f89665962dcaab4cb2b246359ba1',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(RetroRobot2)
    },  {
        id: '53398a713b144ecda6ec32fb4a8d28e1',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(RetroRobot3)
    },

    //Robot
    {
        id: '89679608327ad572b93225d06fe9edda',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Robot1)
    }, {
        id: '36d1098b880dbe47e58d93e7b2842381',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Robot2)
    },  {
        id: '4f5441207afc9bc075b0b404dbba8b59',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Robot3)
    },  {
        id: '10060b3b58c77345cfe92288a46e5c20',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Robot4)
    },

    //Rocketship
    {
        id: '525c06ceb3a351244bcd810c9ba951c7',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Rocketship1)
    }, {
        id: '10f83786e5ee34f40ee43b49bba89ee2',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Rocketship2)
    },  {
        id: 'a6ff2f1344a18cc0a4bcc945e00afaf4',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Rocketship3)
    },  {
        id: '5682c68af2cc8aea791f0373e9ed03d8',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Rocketship4)
    },  {
        id: '49ee475c516a444d8a512724063b8b98',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Rocketship5)
    },

    //Rocks
    {
        id: '0ae345deb1c81ec7f4f4644c26ac85fa',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Rocks)
    },

    //Baseball1
    {
        id: '825d9b54682c406215d9d1f98a819449',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Baseball1)
    },

    //Baseball2
    {
        id: '7be1f5b3e682813dac1f297e52ff7dca',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Baseball2)
    },

    //Basketball1
    {
        id: 'ae21eac3d1814aee1d37ae82ea287816',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Basketball1)
    },

    //BlueSky1
    {
        id: 'e7c147730f19d284bcd7b3f00af19bb6',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(BlueSky1)
    },

    //BlueSky2
    {
        id: '8eb8790be5507fdccf73e7c1570bbbab',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(BlueSky2)
    },

    //Circles
    {
        id: 'c9847be305920807c5597d81576dd0c4',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Circles)
    },

    //Hearts
    {
        id: 'f98526ccb0eec3ac7d6c8f8ab502825e',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Hearts)
    },

    //Jurassic
    {
        id: '64025bdca5db4938f65597e3682fddcf',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Jurassic)
    },

    //Light
    {
        id: '4b98c07876ed8997c3762e75790507b4',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Light)
    },

    //Party
    {
        id: '108160d0e44d1c340182e31c9dc0758a',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Party)
    },

    //Rays
    {
        id: '87e963282db9e020e8c4d075891ea12b',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Rays)
    },

    //Refrigerator
    {
        id: '98f053f9681e872f34fafd783ce72205',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Refrigerator)
    },

    //Stripes
    {
        id: 'a6a21f5c08d586e8daaebde37c97fb6f',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Stripes)
    },

    //Underwater1
    {
        id: 'd3344650f594bcecdf46aa4a9441badd',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Underwater1)
    },

    //Winter
    {
        id: '5fa9385a60b904672d0e46e9d768bb32',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Winter)
    },

    //Woods
    {
        id: 'f3eb165d6f3fd23370f97079f2e631bf',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(Woods)
    },

    ];
};

export default defaultProject;
